(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artwork-preview"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-apv]').forEach(function (root) {
    var cfgEl = root.querySelector('[data-apv-config]');
    if (!cfgEl) return;

    var CFG;
    try {
      CFG = JSON.parse(cfgEl.textContent);
    } catch (e) {
      return;
    }

    var RESTORE_KEY = 'wkd:artwork-params';
    // 2026-09-23: approving no longer navigates away (see the approve click handler below), so
    // this is never SET anymore -- only still read, harmlessly, by the change-request form's
    // post-redirect handling below (which stays a real Shopify contact-form submit). Kept
    // rather than ripped out so that code doesn't need touching too.
    var APPROVED_KEY = 'wkd:approved';

    // Shopify's contact form redirects back here without our query string, so a
    // returning customer would otherwise land on "this link is missing its
    // artwork". Put the stashed parameters back before anything reads them.
    var params = new URLSearchParams(window.location.search);
    var justPosted = params.get('contact_posted') === 'true';

    if (!params.get('a') && !params.get('art')) {
      try {
        var stashed = window.sessionStorage.getItem(RESTORE_KEY);
        if (stashed) {
          var restored = new URLSearchParams(stashed);
          if (justPosted) restored.set('contact_posted', 'true');
          params = restored;
          window.history.replaceState({}, '', window.location.pathname + '?' + restored.toString());
        }
      } catch (err) {
        /* private mode — fall through to the missing-artwork panel */
      }
    }

    var demo = root.getAttribute('data-demo') === '1';

    // Everything below arrives from an emailed URL, so nothing is trusted.
    //
    // The print URL is handed to Gelato as the file to physically print, so it
    // must not be attacker-controllable. Current links carry a bare filename
    // and the CDN prefix is rebuilt here, which makes an off-CDN URL
    // unrepresentable. Links sent before that change carried a full URL, so
    // those are still accepted — but only on the store's own CDN host.
    var CDN_HOST = 'cdn.shopify.com';

    function resolveImage(raw) {
      if (!raw) return '';
      var value = String(raw).trim();

      if (value.indexOf('://') === -1) {
        // Filename form. No slashes, no traversal, no query — just a file.
        if (!/^[A-Za-z0-9._-]+$/.test(value)) return '';
        if (value.indexOf('..') !== -1) return '';
        // Must come out absolute: this string is handed to Gelato as the file
        // to print, and Liquid's file_url is protocol-relative ("//host/…"),
        // which is fine for an <img> but not for a server fetching it.
        try {
          return new URL(CFG.cdnPrefix + value, window.location.href).href;
        } catch (e) {
          return '';
        }
      }

      try {
        var u = new URL(value);
        if (u.protocol !== 'https:') return '';
        if (u.hostname !== CDN_HOST) return '';
        return u.href;
      } catch (e) {
        return '';
      }
    }

    function safeText(raw, max) {
      if (!raw) return '';
      return String(raw).replace(/\s+/g, ' ').trim().slice(0, max || 60);
    }

    // Short keys are what the pipeline sends now; the long ones keep links that
    // were already emailed working.
    function param(short, long) {
      return params.get(short) || params.get(long);
    }

    var artUrl = resolveImage(param('a', 'art'));
    // The print file is the full-resolution upscale Gelato actually prints.
    // Older links predate the upscale step and carry only the display image.
    var printUrl = resolveImage(param('p', 'print')) || artUrl;
    var ref = safeText(param('r', 'ref'), 40);
    // The pipeline once sent the literal text "undefined" for a blank car description (WKD-1027/1040);
    // treat that, and "null", as no value instead of printing it on the plate.
    function nameText(raw, max) {
      var t = safeText(raw, max);
      return /^(undefined|null)$/i.test(t) ? '' : t;
    }
    var customerName = nameText(param('n', 'name'), 40);
    var carName = nameText(param('c', 'car'), 60);

    if (!artUrl && demo) {
      artUrl = CFG.demoArt;
      printUrl = CFG.demoArt;
      customerName = CFG.demoName;
      carName = CFG.demoCar;
    }

    var missing = root.querySelector('[data-missing]');
    var scope = root.querySelector('[data-scope]');
    var closing = root.querySelector('[data-close]');

    var mailHref = 'mailto:' + CFG.contactEmail;
    // "I'm online" chat button: open Shopify's chat panel when the widget is on the page (its element is
    // <shopify-chat>, opened by setting .open). Without the widget the link is the mailto: set just below.
    root.querySelectorAll('[data-open-chat]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var chat = document.querySelector('shopify-chat');
        if (!chat) return;
        e.preventDefault();
        try {
          chat.open = true;
        } catch (err) {
          window.location.href = a.href;
        }
      });
    });

    root.querySelectorAll('[data-missing-mail], [data-close-mail]').forEach(function (a) {
      a.setAttribute('href', mailHref);
    });

    var isOrder = CFG.mode === 'order';

    // Set by the pipeline for links generated from a product-page purchase.
    // The customer has already paid, so this preview is an approval, not a
    // sale — never show them a price or a buy button again.
    var isPaid = !isOrder && (param('k', 'paid') === '1');
    if (isPaid) root.classList.add('is-paid');

    // Remember this link so header.liquid can surface a "View Your Artwork"
    // pill on whatever page they land on next in this browser — e.g. clicking
    // a Facebook retargeting ad to the homepage instead of using this exact
    // emailed URL again. contact_posted is a one-time redirect flag, not
    // meaningful on a later visit, so it's stripped before saving.
    if (!isOrder && !demo && artUrl && ref) {
      try {
        var returnParams = new URLSearchParams(params.toString());
        returnParams.delete('contact_posted');
        window.localStorage.setItem('wkd:returnLink', JSON.stringify({
          href: window.location.pathname + '?' + returnParams.toString(),
          name: customerName,
          ts: Date.now()
        }));
      } catch (e) {
        /* private mode / storage disabled — the pill just never appears */
      }
    }

    // Order mode has no artwork yet — the customer supplies the photo — so the
    // missing-artwork guard does not apply.
    if (!artUrl && !isOrder) {
      if (missing) missing.hidden = false;
      return;
    }

    if (scope) scope.hidden = false;
    if (closing) closing.hidden = false;

    // ── Is this still the current link? (2026-09-23) ─────────────
    // After a change request the customer gets a new link, but the old email still works. Ask the
    // pipeline whether THIS link has been replaced; if so, show only the "updated" panel with a
    // button to the new version, so nobody approves (or buys) the previous artwork. Fails open:
    // no answer, or an unrecognised link, leaves the page exactly as it was.
    // Wes's personal offer (assets/artwork-offer.js): created on first use, never on a paid link.
    var WO = null;
    function offerApi() {
      if (!WO && !isOrder && !isPaid && window.WKDOffer) {
        WO = window.WKDOffer.init({ root: root, rerender: function () { if (primaryController) primaryController.render(); } });
      }
      return WO;
    }
    function offerOn() {
      var o = offerApi();
      return !!o && o.active();
    }

    (function checkLinkIsCurrent() {
      var art = safeText(param('a', 'art'), 120);
      if (isOrder || demo || !ref || !CFG.approveEndpoint || !/^[A-Za-z0-9._-]+$/.test(art)) return;
      var statusUrl = CFG.approveEndpoint.replace(/\/approve$/, '/link-status') +
        '?ref=' + encodeURIComponent(ref) + '&art=' + encodeURIComponent(art);
      fetch(statusUrl)
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          if (data && data.status === 'current' && data.offer && offerApi()) {
            offerApi().set(data.offer);
            return;
          }
          if (!data || (data.status !== 'superseded' && data.status !== 'updating')) return;
          var panel = root.querySelector('[data-superseded]');
          if (!panel) return;
          var linkEl = panel.querySelector('[data-superseded-link]');
          if (data.status === 'superseded' && data.link && /^https:\/\/[^/]*weskleedesigns\.com\//.test(data.link)) {
            if (linkEl) linkEl.setAttribute('href', data.link);
          } else {
            var t = panel.querySelector('[data-superseded-title]');
            var b = panel.querySelector('[data-superseded-body]');
            if (t) t.textContent = "I'm updating your artwork.";
            if (b) b.textContent = "This link shows an earlier version. I'm making the changes you asked for, and I'll email you the new version as soon as it's ready.";
            // .btn sets display:inline-flex, which beats the hidden attribute (see CLAUDE.md traps).
            if (linkEl) linkEl.style.display = 'none';
          }
          root.classList.add('is-superseded');
          panel.hidden = false;
        })
        .catch(function () { /* fail open — see above */ });
    })();

    // ── Personalized copy ────────────────────────────────────────
    var titleEl = root.querySelector('[data-title]');
    var noteEl = root.querySelector('[data-note]');

    function renderTitle() {
      if (!titleEl) return;
      var tpl = customerName ? CFG.headingPersonal : CFG.headingGeneric;
      titleEl.textContent = '';
      // [name] and [car] are filled from the link and always get the
      // sunset-gradient emphasis. Any other token (e.g. [custom], [artwork])
      // renders as that word itself, and is flamed ONLY when there is no car
      // name -- with a car name the car alone carries the accent (2026-10-04).
      var parts = tpl.split(/(\[[a-z]+\])/i);
      for (var i = 0; i < parts.length; i++) {
        var chunk = parts[i];
        var m = /^\[([a-z]+)\]$/i.exec(chunk);
        if (!m) {
          if (chunk) titleEl.appendChild(document.createTextNode(chunk));
          continue;
        }
        var key = m[1].toLowerCase();
        var text = key === 'name' ? customerName : key === 'car' ? carName : m[1];
        if (!text) {
          // Drop the token and the space that followed it.
          if (parts[i + 1]) parts[i + 1] = parts[i + 1].replace(/^\s+/, '');
          continue;
        }
        if (carName && key !== 'name' && key !== 'car') {
          titleEl.appendChild(document.createTextNode(text));
          continue;
        }
        var em = document.createElement('em');
        em.className = 'flame';
        em.textContent = text;
        titleEl.appendChild(em);
      }
    }

    function renderNote() {
      if (!noteEl) return;
      // Paid/approve-only links (?k=1) get a note that doesn't tell them to "choose printing
      // options" -- they already paid, there's nothing left to pick. Falls back to the regular
      // note if note_paid was left blank (2026-09-23, Wes's request).
      var template = (isPaid && CFG.notePaid) ? CFG.notePaid : CFG.note;
      noteEl.textContent = template.split('[car]').join(carName || CFG.carFallback);
    }

    renderTitle();
    renderNote();

    // Simplified order form: the framed artwork stage lives inside step 1 (see snippets/apv-vehicle.liquid),
    // not above the form. Moved before anything else looks it up; every lookup below is by data attribute
    // from root, so the move changes nothing for the drawing code.
    if (isOrder && CFG.orderV2) {
      var stageSlot = root.querySelector('[data-stage-slot]');
      var stageHero = root.querySelector('.apv-hero');
      if (stageSlot && stageHero) stageSlot.appendChild(stageHero);
    }

    var artEl = root.querySelector('[data-art]');
    if (artEl && artUrl) {
      artEl.src = artUrl;
      if (carName) artEl.alt = 'Your commissioned artwork of your ' + carName;
    }

    var orderForm = root.querySelector('[data-order-form]');

    // Nothing to show until they pick a photo, so the whole artwork box stays
    // out of the layout rather than sitting there empty. Photo upload itself
    // (per vehicle in order mode) is wired inside createConfigController
    // below, since each vehicle — or the single preview-mode picker — has
    // its own upload zone now.
    var watermarkEl = root.querySelector('.apv-watermark');
    var watermarkText = watermarkEl ? watermarkEl.textContent : '';
    // (CFG.orderV2, not v2o: v2o is assigned further down the script, after this runs.)
    // No framed preview until a photo has been added (there is nothing real to show before that).
    if (isOrder) root.classList.add('is-awaiting-photo');

    // ── Variant lookup ───────────────────────────────────────────
    // The design shows Material × Frame; the product stores Product × Style,
    // where "framed" is a different physical product (and a different Gelato
    // SKU) rather than an attribute. Map the design's pair onto that pair.
    //
    // Anything this returns null for, or that has no matching variant, is a
    // combination Gelato cannot actually make — the card renders unavailable
    // and checkout is blocked. Notably: no 20x30 on paper (Gelato tops out at
    // 16x24 for framed posters), and no white framed canvas at all.
    var STYLE_BY_FRAME = {
      none: CFG.styleNone,
      black: CFG.styleBlack,
      natural: CFG.styleNatural,
      dark: CFG.styleDark,
      white: CFG.styleWhite
    };

    function comboOptionValue(material, frame) {
      var style = STYLE_BY_FRAME[frame];
      if (!style) return null;

      var framed = frame !== 'none';
      var product;
      if (material === 'print') {
        product = framed ? CFG.prodFramedPrint : CFG.prodPrint;
      } else if (material === 'canvas') {
        product = framed ? CFG.prodFramedCanvas : CFG.prodCanvas;
      }
      if (!product) return null;

      return { product: product, style: style };
    }

    function findVariant(sizeValue, material, frame) {
      var combo = comboOptionValue(material, frame);
      if (!combo) return null;
      for (var i = 0; i < CFG.variants.length; i++) {
        var v = CFG.variants[i];
        if (v.size === sizeValue && v.product === combo.product && v.style === combo.style && v.available) {
          return v;
        }
      }
      return null;
    }

    function money(cents) {
      var n = cents / 100;
      return '$' + (n % 1 === 0 ? n.toLocaleString('en-US') : n.toFixed(2));
    }

    // The companion is the SAME 12 × 18″ poster this product already sells,
    // so its price has to come from that variant rather than from the typed
    // `companion_price` setting — one price rise in Shopify would otherwise
    // leave the form quoting the old number and checkout charging the new
    // one. The setting survives only as a fallback for a companion that
    // lives on some other product, where no variant here can answer.
    function companionVariant() {
      var id = CFG.companion.variantId;
      if (!id) return null;
      for (var i = 0; i < CFG.variants.length; i++) {
        if (String(CFG.variants[i].id) === String(id)) return CFG.variants[i];
      }
      return null;
    }

    function companionPrice() {
      var v = companionVariant();
      return v ? v.price : CFG.companion.price;
    }

    // ── "Add a second one" duplicate ─────────────────────────────
    // Mirrors whatever the primary configurator currently resolves to, so
    // there is nothing for the customer to choose and nothing that can fall
    // out of step with the piece they are actually buying.
    function dupeDiscount(cents) {
      var pct = Number(CFG.dupe.percent) || 0;
      if (pct <= 0) return cents;
      return Math.round((cents * (100 - pct)) / 100);
    }

    // Whether the duplicate is genuinely part of this order. Hidden — and
    // force-cleared — the moment it stops being answerable: no variant
    // selected, or a second vehicle added, where "a second one" no longer
    // names one thing.
    function dupeEligible() {
      if (!CFG.dupe.enabled || !primaryController) return false;
      if (isOrder && vehicleControllers.length !== 1) return false;
      return true;
    }

    function dupeItem(variant, subtitle) {
      if (!variant) return null;
      return {
        variant: variant,
        list: variant.price,
        price: dupeDiscount(variant.price),
        pct: Number(CFG.dupe.percent) || 0,
        label: subtitle ? CFG.dupe.summaryPrefix + ' ' + subtitle : CFG.dupe.summaryPrefix
      };
    }

    // The "second copy" line, appended to whichever summary container is
    // rendering right now (2026-09-12). Shared by order mode's
    // renderOrderSummary and preview mode's render() below (which writes
    // its own plain-text summary line directly, rather than building
    // .apv-summary-row nodes the way order mode does) — one place to build
    // this row so the two paths can't drift apart, same reasoning as the
    // rest of this snippet's sharing.
    //
    // Ticking .apv-dupe (the offer/checkbox rendered above the summary)
    // hides that whole block (see renderDupe) — this row is what replaces
    // it, with its own Remove control that flips dupeOn back off. Rebuilt
    // fresh on every call since the container itself is always cleared and
    // rebuilt first, so the click handler can just be attached here rather
    // than wired once and hunted for on every render.
    function appendDupeSummary(container, dupe) {
      if (!container || !dupe) return;

      var dupeRowEl = document.createElement('div');
      dupeRowEl.className = 'apv-summary-row apv-summary-dupe';
      var dupeLabelEl = document.createElement('span');
      dupeLabelEl.className = 'apv-summary-row-label';
      dupeLabelEl.textContent = dupe.label;
      var dupePriceEl = document.createElement('span');
      dupePriceEl.className = 'apv-summary-row-price';
      dupePriceEl.textContent = signedMoney(dupe.price);
      dupeRowEl.appendChild(dupeLabelEl);
      dupeRowEl.appendChild(dupePriceEl);
      container.appendChild(dupeRowEl);

      var dupeMetaEl = document.createElement('div');
      dupeMetaEl.className = 'apv-summary-dupe-meta';
      if (dupe.pct > 0) {
        var dupeTagEl = document.createElement('span');
        dupeTagEl.className = 'apv-summary-off';
        dupeTagEl.textContent = dupe.pct + '% ' + CFG.dupe.offLabel;
        dupeMetaEl.appendChild(dupeTagEl);
      }
      var dupeRemoveEl = document.createElement('button');
      dupeRemoveEl.type = 'button';
      dupeRemoveEl.className = 'apv-summary-dupe-remove';
      dupeRemoveEl.textContent = CFG.dupe.removeLabel;
      dupeRemoveEl.addEventListener('click', function () {
        dupeOn = false;
        dupeChanged();
        // Focus lands back on the checkbox rather than nowhere: the
        // element just clicked is gone from the DOM a moment later (this
        // whole render rebuilds), and the offer reappearing right where
        // the checkbox used to be is the most sensible place for a
        // keyboard user to land next.
        if (dupeCheck) dupeCheck.focus();
      });
      dupeMetaEl.appendChild(dupeRemoveEl);
      container.appendChild(dupeMetaEl);
    }

    // Draws the checkbox from the currently selected variant. `subtitle` is
    // the configurator's own one-line recap ("16 × 24″ · Wrapped Canvas"),
    // so the offer always names the exact piece being duplicated rather than
    // a generic "second print".
    //
    // 2026-09-12: this only ever renders the OFFER look now -- the instant
    // dupeOn is true, the whole thing hides and renderOrderSummary draws
    // the "second copy" as its own line instead (with its own Remove
    // control there). Two clean states, not one row restyling itself in
    // place, so there is no "ticked" branch left to draw here.
    function renderDupe(variant, subtitle) {
      if (!dupeWrap || !dupeCheck) return;
      var eligible = dupeEligible() && !!variant;
      // Clearing the flag isn't enough — the control's own ticked state has to
      // come off with it, or one that became ineligible while ticked leaves
      // the offer permanently hidden with no way back to it.
      if (!eligible) dupeOn = false;
      dupeWrap.hidden = !eligible || dupeOn;
      if (!eligible || dupeOn) return;

      var pct = Number(CFG.dupe.percent) || 0;

      var labelEl = dupeCheck.querySelector('[data-dupe-label]');
      if (labelEl) labelEl.textContent = CFG.dupe.label;

      var descEl = dupeCheck.querySelector('[data-dupe-desc]');
      if (descEl) {
        descEl.hidden = false;
        descEl.textContent = (CFG.dupe.note || '').replace('[piece]', subtitle || '').trim();
      }

      var wasEl = dupeCheck.parentNode.querySelector('[data-dupe-was]');
      var nowEl = dupeCheck.parentNode.querySelector('[data-dupe-now]');
      var offEl = dupeCheck.querySelector('[data-dupe-off]');
      if (wasEl) {
        wasEl.textContent = pct > 0 ? money(variant.price) : '';
        wasEl.hidden = pct <= 0;
      }
      if (nowEl) nowEl.textContent = money(dupeDiscount(variant.price));
      if (offEl) {
        offEl.textContent = pct > 0 ? pct + '% ' + CFG.dupe.offLabel : '';
        offEl.hidden = pct <= 0;
      }
    }

    // Cart fields for the duplicate. Rebuilt every time, so a variant change
    // or an untick can never leave a stale id behind — the failure mode that
    // would ship someone the wrong second print.
    function syncDupeFields(idx, item) {
      if (!dupeFieldsEl) return;
      dupeFieldsEl.textContent = '';
      if (!item) return;
      function add(suffix, value) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'items[' + idx + ']' + suffix;
        input.value = value;
        dupeFieldsEl.appendChild(input);
      }
      add('[id]', String(item.variant.id));
      add('[quantity]', '1');
      // Same marker as every other extra print — keeps the pipeline from
      // reading it as a second commission to paint.
      add('[properties][' + COMPANION_KEY + ']', CFG.companionPropertyValue);
    }

    // The main piece's properties plus the companion marker. Preview mode
    // only — order mode carries the same key on a hidden input instead,
    // because its add-to-cart is a native form submit.
    function companionProps(props) {
      var out = {};
      Object.keys(props).forEach(function (k) {
        out[k] = props[k];
      });
      out[COMPANION_KEY] = CFG.companionPropertyValue;
      return out;
    }

    // A variant's was-price, or 0 when there is nothing to strike through.
    // Guards against a compare-at that is equal to or BELOW the live price:
    // Shopify happily stores either, and both would render as a "saving" of
    // zero or less — an obviously broken price tag on the one element of
    // this page a wavering customer scrutinises hardest.
    function compareAtOf(v) {
      return v && v.compareAt > v.price ? v.compareAt : 0;
    }

    // What a variant is worth before any markdown — its compare-at when it
    // has one, otherwise just its price. Summing this across an order gives
    // the strike-through total to set the real total against.
    function listPriceOf(v) {
      return v ? compareAtOf(v) || v.price : 0;
    }

    // Writes one size card's price. Built out of real nodes rather than an
    // innerHTML string so a price can never carry markup, and so the struck
    // was-price stays its own element for CSS to size and dim separately.
    // saveEl is a separate sibling slot (data-size-save -- deliberately not
    // data-save, which .apv-save the order-total line already owns), not a
    // child of el -- size cards put the price inline with the title and the
    // save tag inline with the note underneath, two different grid rows, so
    // the two can't share one container the way a single flowed price block
    // could. The was-price stacks with the live price instead (was on top,
    // see .apv-card-was's display:block below), not with save, so the whole
    // was+now price still reads as one figure sitting with the title.
    function renderCardPrice(el, saveEl, v) {
      if (!el) return;
      el.textContent = '';
      if (saveEl) saveEl.textContent = '';
      if (!v) {
        el.textContent = CFG.soonLabel;
        return;
      }

      var was = compareAtOf(v);
      if (was) {
        var wasEl = document.createElement('s');
        wasEl.className = 'apv-card-was';
        wasEl.textContent = money(was);
        el.appendChild(wasEl);
      }

      var nowEl = document.createElement('span');
      nowEl.className = 'apv-card-now';
      nowEl.textContent = money(v.price);
      el.appendChild(nowEl);

      // Deliberately the dollar amount only — the percentage lives on the
      // one savings line under the total. Four size cards each doing their
      // own "$50 (17%)" is four sums to check on the screen where the whole
      // point is that the choice should be easy.
      if (was && saveEl) {
        var saveEl2 = document.createElement('span');
        saveEl2.className = 'apv-card-save';
        saveEl2.textContent = CFG.saveShortLabel + ' ' + money(was - v.price);
        saveEl.appendChild(saveEl2);
      }
    }

    // ── Elements + state ─────────────────────────────────────────
    // Preview mode has exactly one of these (the single .apv-config picker).
    // Order mode has one per vehicle card instead — see createConfigController
    // below, which is what actually queries [data-size]/[data-material]/
    // [data-frame] now, scoped to whichever element it's handed rather than
    // to root. viewBtns stays root-scoped: the flat/room toggle exists once,
    // in the shared stage, regardless of mode.
    var viewBtns = Array.prototype.slice.call(root.querySelectorAll('[data-view]'));

    var loveBtn = root.querySelector('[data-love]');
    var loveMark = root.querySelector('[data-love-mark]');
    var changeToggle = root.querySelector('[data-change-toggle]');
    var changeBox = root.querySelector('[data-changebox]');
    var changeSentBox = root.querySelector('[data-changesent]');
    var lovedMsg = root.querySelector('[data-loved]');
    var companionBtn = root.querySelector('[data-companion]');
    var companionMark = root.querySelector('[data-companion-mark]');
    var companionIdInput = root.querySelector('[data-companion-id]');
    var companionQtyInput = root.querySelector('[data-companion-qty]');
    var companionTagInput = root.querySelector('[data-companion-tag]');
    var dupeWrap = root.querySelector('[data-dupe-wrap]');
    var dupeCheck = root.querySelector('[data-dupe]');
    var dupeFieldsEl = root.querySelector('[data-dupe-fields]');
    // Order-level, not per-vehicle: the duplicate is a second copy of the
    // finished artwork, so it belongs to the order rather than to any one
    // car on it.
    var dupeOn = false;
    var companionPriceEl = root.querySelector('[data-companion-price]');
    // The property key the pipeline's vehicle filter excludes on — see the
    // markup comment beside [data-companion-tag]. Both ends must agree.
    var COMPANION_KEY = 'Companion print';

    var artwrap = root.querySelector('[data-artwrap]');
    var frameband = root.querySelector('[data-frameband]');
    var mat = root.querySelector('[data-mat]');
    var framePhoto = root.querySelector('[data-frame-photo-img]');
    var plaque = root.querySelector('[data-plaque]');

    var totalEl = root.querySelector('[data-total]');
    var totalWasEl = root.querySelector('[data-total-was]');
    var saveEl = root.querySelector('[data-save]');
    var summaryEl = root.querySelector('[data-summary]');
    var unavailableEl = root.querySelector('[data-unavailable]');
    var buyBtns = Array.prototype.slice.call(root.querySelectorAll('[data-buy]'));

    // Room-view toggle stays global — one stage, whichever vehicle is
    // "primary" (vehicle 0 in order mode; the only one in preview mode).
    var roomState = { room: false };

    // ── Roving-tabindex keyboard support for each radiogroup ─────
    // The prototype had none; arrow keys are required for a real radiogroup.
    function wireGroup(btns, onPick) {
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () {
          onPick(i);
        });
        b.addEventListener('keydown', function (e) {
          var dir = 0;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
          if (!dir) return;
          e.preventDefault();
          var next = (i + dir + btns.length) % btns.length;
          onPick(next);
          btns[next].focus();
        });
      });
    }

    wireGroup(viewBtns, function (i) {
      roomState.room = viewBtns[i].getAttribute('data-view') === 'room';
      viewBtns.forEach(function (b) {
        var on = (b.getAttribute('data-view') === 'room') === roomState.room;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.setAttribute('tabindex', on ? '0' : '-1');
      });
      root.classList.toggle('is-room', roomState.room);
      if (primaryController) primaryController.render();
    });

    // Order mode sums across vehicles; preview mode writes its own total
    // inside render(). Same two paths every other price change takes.
    function dupeChanged() {
      if (isOrder) updateOrderTotals();
      else if (primaryController) primaryController.render();
    }

    // Only ever clickable while it's showing the offer (dupeOn false, or the
    // row would be hidden) -- an explicit "add" rather than a toggle now that
    // there's nothing left to toggle back to from here. Removing it happens
    // from the summary row's own Remove control instead (renderOrderSummary),
    // not by clicking this same element a second time.
    if (dupeCheck) {
      dupeCheck.addEventListener('click', function () {
        dupeOn = true;
        dupeChanged();
      });
    }

    if (companionBtn) {
      companionBtn.addEventListener('click', function () {
        if (!primaryController) return;
        primaryController.state.companion = !primaryController.state.companion;
        primaryController.render();
        if (isOrder) updateOrderTotals();
      });
    }

    // ── Redesigned picker + order card (2026-10-06, Wes's mock-up) ──────
    // PRESENTATION LAYER ONLY. The original finish / colour / size controls still live inside
    // [data-config] (hidden, see snippets/apv-v2.liquid) and stay the only thing that knows about
    // variants, the stage drawing and the cart. Every control of the new layout clicks the matching
    // legacy control, and syncV2() (called at the end of every render()) mirrors the legacy state
    // back. Preview mode only: order mode has no apv--v2 class and v2 stays null.
    var v2 = root.classList.contains('apv--v2') && !isOrder ? CFG.v2 || {} : null;
    // 2026-10-09: the order form (order-landing-standard) can show the same picker, one per vehicle.
    // Only the PICKER half is shared (syncV2Pick); the pinned art, plate, zoom and order card in
    // syncV2 / v2DockInit / v2ZoomInit stay preview-only, so v2 itself is still null in order mode.
    var v2o = isOrder && CFG.orderV2 ? CFG.v2 || {} : null;
    var v2cfg = v2 || v2o;
    var V2_STYLE_WORD = { oil: 'Oil', sketch: 'Sketch' };
    // Lets the stylesheet un-stick the site header on this page (phone portrait only, see the CSS).
    if (v2) document.documentElement.classList.add('apv-v2-page');
    var v2DockState = null;

    function v2Legacy(scope) {
      var cfg = (scope || root).querySelector('[data-config]');
      function q(sel) {
        return cfg ? Array.prototype.slice.call(cfg.querySelectorAll(sel)) : [];
      }
      return { sizes: q('[data-size]'), frames: q('[data-frame]'), finishes: q('[data-finish]') };
    }
    function v2FinishBtn(L, key) {
      return L.finishes.filter(function (b) { return b.getAttribute('data-finish') === key; })[0] || null;
    }
    function v2Active(L) {
      var on = L.finishes.filter(function (b) { return b.classList.contains('is-on'); })[0];
      if (!on) return null;
      return {
        material: on.getAttribute('data-finish-material'),
        framed: on.getAttribute('data-finish-framed') === 'true'
      };
    }
    function v2Click(btn) {
      if (btn && !btn.hidden) btn.click();
    }
    function v2NormSize(t) {
      return String(t || '').toLowerCase().replace(/\s+/g, '').replace(/\u00d7/g, 'x');
    }
    function v2SpanLast(btns) {
      // Counts only buttons that are really on screen: a stylesheet can hide some (the landing and product pages
      // show only Black or None), and counting those stretched None across the row on its own.
      var shown = btns.filter(function (b) { return !b.hidden && window.getComputedStyle(b).display !== 'none'; });
      btns.forEach(function (b) { b.classList.remove('apv2-span-full'); });
      if (shown.length % 2 === 1) shown[shown.length - 1].classList.add('apv2-span-full');
    }
    // Shows a description under a row, replaying a short fade whenever the text changes.
    function v2SetDesc(kind, text, scope) {
      var el = (scope || root).querySelector('[data-v2-desc="' + kind + '"]');
      if (!el) return;
      var t = text || '';
      if (el.textContent === t && el.hidden === !t) return;
      el.textContent = t;
      el.hidden = !t;
      el.classList.remove('is-fresh');
      if (t) {
        void el.offsetWidth;
        el.classList.add('is-fresh');
      }
    }
    // Order form only: a small "Recommended" tag (CSS draws it from data-rec) on the recommended choices.
    function v2Rec(b, on) {
      var label = v2o && v2o.recommendLabel;
      if (on && label) b.setAttribute('data-rec', label);
      else b.removeAttribute('data-rec');
    }
    function v2Mark(b, on) {
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    }

    // scope: root (preview page, one picker) or one .apv-vehicle (order form, one picker per vehicle).
    function v2Wire(scope) {
      if (!v2cfg) return;
      scope = scope || root;
      Array.prototype.forEach.call(scope.querySelectorAll('[data-v2-tab]'), function (b) {
        b.addEventListener('click', function () {
          var L = v2Legacy(scope);
          var a = v2Active(L);
          if (!a) return;
          var mat = b.getAttribute('data-v2-tab');
          // Keep the framed / unframed choice when switching between canvas and print.
          var target = v2FinishBtn(L, (a.framed ? 'framed-' : '') + mat);
          if (!target || target.hidden) target = v2FinishBtn(L, mat);
          v2Click(target);
        });
      });
      Array.prototype.forEach.call(scope.querySelectorAll('[data-v2-frame]'), function (b) {
        b.addEventListener('click', function () {
          var L = v2Legacy(scope);
          var a = v2Active(L);
          if (!a) return;
          var key = b.getAttribute('data-v2-frame');
          if (key === 'none') {
            v2Click(v2FinishBtn(L, a.material));
            return;
          }
          if (!a.framed) v2Click(v2FinishBtn(L, 'framed-' + a.material));
          v2Click(L.frames.filter(function (c) { return c.getAttribute('data-frame') === key; })[0]);
        });
      });
      Array.prototype.forEach.call(scope.querySelectorAll('[data-v2-size]'), function (b) {
        b.addEventListener('click', function () {
          v2Click(v2Legacy(scope).sizes[Number(b.getAttribute('data-v2-size'))]);
        });
      });
    }

    // Full-screen artwork viewer. Tap the art (or the expand button) to open the artwork alone on black.
    // It loads the full-resolution print file for crisp pinch-zoom, falling back to the display image.
    // Best effort on Android: ask for fullscreen + landscape lock (both need the tap that opened it);
    // iPhone has no such API, so the "turn your phone sideways" hint does that job. Closing: the X, a
    // tap anywhere, Escape, or the phone's back button (a history entry is pushed while it is open).
    function v2ZoomInit() {
      if (!v2) return;
      var artwrapEl = root.querySelector('[data-artwrap]');
      if (!artwrapEl) return;

      var EXPAND_SVG =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="square" aria-hidden="true"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>';
      var CLOSE_SVG =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
      var TURN_SVG =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><rect x="7" y="2.5" width="10" height="19" rx="0"/><path d="M11 18.5h2"/></svg>';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'apv2-zoom';
      btn.setAttribute('aria-label', 'Zoom: view the artwork larger');
      btn.innerHTML = EXPAND_SVG + '<span>Zoom</span>';
      var plaqueEl = root.querySelector('[data-plaque]');
      if (plaqueEl && plaqueEl.parentNode) plaqueEl.parentNode.insertBefore(btn, plaqueEl.nextSibling);
      else artwrapEl.appendChild(btn);
      artwrapEl.classList.add('is-zoomable');

      var lb = null;
      var img = null;
      var opened = false;
      var pushed = false;
      var lockedOrientation = false;

      function build() {
        lb = document.createElement('div');
        lb.className = 'apv2-lb';
        lb.hidden = true;
        lb.setAttribute('role', 'dialog');
        lb.setAttribute('aria-modal', 'true');
        lb.setAttribute('aria-label', 'Your artwork, full screen');
        lb.innerHTML =
          '<img class="apv2-lb-img" alt="">' +
          '<button type="button" class="apv2-lb-close" aria-label="Close">' + CLOSE_SVG + '</button>' +
          '<div class="apv2-lb-hint" aria-hidden="true">' + TURN_SVG + '<span>Turn your phone sideways for a bigger view</span></div>';
        document.body.appendChild(lb);
        img = lb.querySelector('.apv2-lb-img');
        lb.addEventListener('click', function () {
          close();
        });
      }

      function releaseOrientation() {
        try {
          if (lockedOrientation && window.screen && screen.orientation && screen.orientation.unlock) screen.orientation.unlock();
        } catch (e) {
          /* nothing to release */
        }
        lockedOrientation = false;
        try {
          if (document.fullscreenElement && document.exitFullscreen) document.exitFullscreen().catch(function () {});
        } catch (e) {
          /* not in fullscreen */
        }
      }

      function tryLandscape() {
        // Phones only; needs the user's tap, so it must be called synchronously from open().
        var phone = window.matchMedia && window.matchMedia('(max-width: 900px) and (pointer: coarse)').matches;
        if (!phone || !lb.requestFullscreen || !window.screen || !screen.orientation || !screen.orientation.lock) return;
        lb.requestFullscreen()
          .then(function () {
            return screen.orientation.lock('landscape');
          })
          .then(function () {
            lockedOrientation = true;
          })
          .catch(function () {
            /* refused: the hint still asks them to turn the phone */
          });
      }

      function open() {
        if (opened) return;
        if (!lb) build();
        opened = true;
        var alt = carName ? 'Your commissioned artwork of your ' + carName : 'Your commissioned artwork';
        img.alt = alt;
        img.src = artUrl;
        if (printUrl && printUrl !== artUrl) {
          var big = new Image();
          big.onload = function () {
            if (opened) img.src = printUrl;
          };
          big.src = printUrl;
        }
        lb.hidden = false;
        document.documentElement.classList.add('apv2-lb-open');
        try {
          history.pushState({ apv2lb: 1 }, '');
          pushed = true;
        } catch (e) {
          pushed = false;
        }
        tryLandscape();
        var closeBtn = lb.querySelector('.apv2-lb-close');
        if (closeBtn && closeBtn.focus) closeBtn.focus();
      }

      function close(fromPop) {
        if (!opened) return;
        opened = false;
        lb.hidden = true;
        document.documentElement.classList.remove('apv2-lb-open');
        releaseOrientation();
        if (pushed && !fromPop) {
          pushed = false;
          try {
            history.back();
          } catch (e) {
            /* nothing to pop */
          }
        } else {
          pushed = false;
        }
        if (btn.focus) btn.focus();
      }

      artwrapEl.addEventListener('click', open);
      btn.addEventListener('click', open);
      window.addEventListener('popstate', function () {
        if (opened) close(true);
      });
      document.addEventListener('keydown', function (e) {
        if (opened && e.key === 'Escape') close();
      });
    }

    // Phone portrait: pins the artwork stage and condenses its plate once it reaches the top.
    // Detected with a 1px sentinel at the TOP of the scope, which the hero's own height change can
    // never move (measuring the hero itself flip-flopped in the past, see CLAUDE.md traps).
    function v2DockInit() {
      if (!v2 || !window.IntersectionObserver || !window.matchMedia) return;
      var hero = root.querySelector('.apv-hero');
      var scopeEl = root.querySelector('[data-scope]');
      if (!hero || !scopeEl) return;
      var mq = window.matchMedia('(max-width: 760px) and (orientation: portrait)');
      var sentinel = document.createElement('div');
      sentinel.className = 'apv-dock-sentinel';
      sentinel.setAttribute('aria-hidden', 'true');
      scopeEl.insertBefore(sentinel, scopeEl.firstChild);
      var offset = parseFloat(getComputedStyle(hero).getPropertyValue('--apv-dock-offset')) || 34;
      var st = { docked: false };

      // The docked hero is shorter. Its margin-bottom gives back exactly that difference so the
      // content under it keeps its place instead of jumping up the moment the art pins.
      // THE FLICKER (2026-10-06): this used to drop the compensation margin, add the docked class and
      // read the small height, so for one forced layout the page below was 127px too short. Chrome's
      // scroll anchoring answered by scrolling the page up by that much (it landed at the top), which
      // un-docked the hero, which docked it again: the art flicked back and forth. Now the margin is
      // never missing (the provisional one is as tall as the full hero, so the page can only be taller
      // than the final answer for a moment, never shorter, and nothing gets clamped), and anchoring
      // is switched off for the duration so even that moment cannot move the scroll position.
      function measure() {
        if (!st.docked) return;
        var rootEl = document.documentElement;
        var anchorWas = rootEl.style.overflowAnchor;
        rootEl.style.overflowAnchor = 'none';
        hero.classList.remove('is-docked');
        var full = hero.getBoundingClientRect().height;
        hero.style.setProperty('--apv-dock-comp', full.toFixed(2) + 'px');
        hero.classList.add('is-docked');
        var small = hero.getBoundingClientRect().height;
        hero.style.setProperty('--apv-dock-comp', Math.max(0, full - small).toFixed(2) + 'px');
        rootEl.style.overflowAnchor = anchorWas;
      }
      // Hysteresis: it docks when the page has scrolled past the pin point, but only undocks once the
      // reader has scrolled back HYST px above it. Docking changes the hero's height, and on Android
      // (scroll anchoring, the address bar resizing the page) that can nudge the scroll position by a
      // few pixels; with a single threshold the nudge crossed it again and the art flicked between the
      // two states while scrolling slowly.
      var HYST = 28;
      function evaluate() {
        var b = sentinel.getBoundingClientRect().bottom;
        var want = mq.matches && (st.docked ? b < -offset + HYST : b < -offset);
        if (want === st.docked) return;
        st.docked = want;
        if (want) {
          measure();
        } else {
          hero.classList.remove('is-docked');
          hero.style.removeProperty('--apv-dock-comp');
        }
      }
      // Root margin pushes the observed edge up by the sticky offset, so it flips exactly when the
      // hero has started to stick.
      new IntersectionObserver(evaluate, { rootMargin: offset + 'px 0px 0px 0px', threshold: [0, 1] }).observe(sentinel);
      // The observer only fires when the pin point is crossed; the undock point is HYST px further
      // up, so a (passive, frame-throttled) scroll listener watches for that one.
      var scrollTick = false;
      window.addEventListener(
        'scroll',
        function () {
          if (scrollTick) return;
          scrollTick = true;
          window.requestAnimationFrame(function () {
            scrollTick = false;
            evaluate();
          });
        },
        { passive: true }
      );
      if (mq.addEventListener) mq.addEventListener('change', evaluate);
      else if (mq.addListener) mq.addListener(evaluate);
      window.addEventListener('resize', function () {
        evaluate();
        measure();
      });
      v2DockState = {
        measure: measure,
        isDocked: function () {
          return st.docked;
        }
      };
    }

    // Opens on the size Wes recommends rather than the cheapest one.
    function v2DefaultSize() {
      if (!v2 || !v2.defaultSize) return;
      var want = v2NormSize(v2.defaultSize);
      var m = v2Legacy().sizes.filter(function (b) {
        var t = b.querySelector('.apv-card-title');
        return t && !b.hidden && v2NormSize(t.textContent) === want;
      })[0];
      if (m && !m.classList.contains('is-on')) m.click();
    }

    // Text of an engine card's description line.
    function v2Note(btn) {
      var n = btn && btn.querySelector('.apv-card-note');
      return n ? n.textContent.trim() : '';
    }

    // The PICKER half of the redesign: marks the tabs / frame / size buttons from the engine's state and
    // writes the description under each row. Scoped so the order form can run it once per vehicle.
    // Returns what the preview page's order card needs, or null when there is nothing to sync.
    function syncV2Pick(scope) {
      var c = v2cfg;
      if (!c) return null;
      scope = scope || root;
      var L = v2Legacy(scope);
      var a = v2Active(L);
      if (!a) return null;

      var matWord = '';
      Array.prototype.forEach.call(scope.querySelectorAll('[data-v2-tab]'), function (b) {
        var mat = b.getAttribute('data-v2-tab');
        b.hidden = !L.finishes.some(function (f) { return f.getAttribute('data-finish-material') === mat && !f.hidden; });
        var on = mat === a.material;
        v2Mark(b, on);
        v2Rec(b, mat === 'canvas');
        if (on) matWord = b.textContent.trim();
      });

      var frameName = '';
      var frameBtns = Array.prototype.slice.call(scope.querySelectorAll('[data-v2-frame]'));
      frameBtns.forEach(function (b) {
        var key = b.getAttribute('data-v2-frame');
        var shown;
        var on;
        if (key === 'none') {
          var plain = v2FinishBtn(L, a.material);
          shown = !!plain && !plain.hidden;
          on = !a.framed;
        } else {
          var framedFinish = v2FinishBtn(L, 'framed-' + a.material);
          var leg = L.frames.filter(function (c) { return c.getAttribute('data-frame') === key; })[0];
          shown = !!leg && !leg.hidden && !!framedFinish && !framedFinish.hidden;
          on = a.framed && !!leg && leg.classList.contains('is-on');
        }
        b.hidden = !shown;
        v2Mark(b, on && shown);
        v2Rec(b, key === 'black' && a.material === 'canvas');
        if (on && shown && key !== 'none') frameName = b.textContent.trim();
      });
      v2SpanLast(frameBtns);

      var sizeTxt = '';
      var sizeBtns = Array.prototype.slice.call(scope.querySelectorAll('[data-v2-size]'));
      sizeBtns.forEach(function (b, i) {
        var leg = L.sizes[i];
        b.hidden = !leg || leg.hidden;
        var on = !!leg && !leg.hidden && leg.classList.contains('is-on');
        v2Mark(b, on);
        v2Rec(b, v2NormSize(b.textContent) === v2NormSize(c.defaultSize));
        if (on) {
          var t = leg.querySelector('.apv-card-title');
          sizeTxt = t ? t.textContent.trim() : '';
        }
      });
      v2SpanLast(sizeBtns);


      // Description of whatever is selected, under each row (like the I love it message).
      var activeSizeBtn = L.sizes.filter(function (b) { return !b.hidden && b.classList.contains('is-on'); })[0];
      v2SetDesc('tab', v2Note(v2FinishBtn(L, a.material)), scope);
      // Order form only: a canvas frame reads "in Black Wood" (the button says Black), and an unframed canvas
      // says what it is. The emailed page's wording is unchanged.
      var frameWord = v2o && a.material === 'canvas' && frameName ? frameName + ' Wood' : frameName;
      var frameDesc = String(a.material === 'canvas' ? c.descFrameCanvas : c.descFramePrint || '')
        .split('[frame]')
        .join(frameWord);
      var noneDesc = v2o && a.material === 'canvas' && c.descNoneCanvas ? c.descNoneCanvas : c.descNone || '';
      v2SetDesc('frame', a.framed ? frameDesc : noneDesc, scope);
      // Product page: the size buttons say Small / Medium / Large / X-Large, so the line under them gives the
      // dimensions first, then the size's own description.
      var sizeLine = v2Note(activeSizeBtn);
      if (root.classList.contains('apv--product') && activeSizeBtn) {
        var dimsEl = activeSizeBtn.querySelector('.apv-card-title');
        sizeLine = [dimsEl ? dimsEl.textContent.trim() : '', sizeLine].filter(Boolean).join(' · ');
      }
      v2SetDesc('size', sizeLine, scope);

      // The selected product's detail lines (the preview page's check rows, minus the two that are about the
      // order rather than the piece). The order form lists them under each piece in its summary.
      var productDesc = v2Note(v2FinishBtn(L, a.material));
      if (a.material === 'canvas') {
        productDesc = productDesc.replace(/\s*(?:[-\u2013\u2014,]\s*)?ready to hang\.?\s*$/i, '').trim();
      }
      var bullets = [productDesc];
      if (a.framed && frameName) bullets.push(frameDesc);
      if (a.material === 'canvas' || a.framed) bullets.push(c.checkReady);
      bullets = bullets.filter(Boolean);
      scope.setAttribute('data-bullets', JSON.stringify(bullets));

      return { L: L, a: a, matWord: matWord, frameName: frameName, sizeTxt: sizeTxt, frameDesc: frameDesc };
    }

    function syncV2() {
      if (!v2 || !primaryController) return;
      var p = syncV2Pick(root);
      if (!p) return;
      var L = p.L;
      var a = p.a;
      var matWord = p.matWord;
      var frameName = p.frameName;
      var sizeTxt = p.sizeTxt;
      var frameDesc = p.frameDesc;

      var sizeShort = v2NormSize(sizeTxt);
      var frameBit = a.framed && frameName ? frameName + ' Frame' : '';
      // The tab says "Canvas"; the summary line and the plate say "Wrapped Canvas" (Wes, 2026-10-06).
      var summaryWord = a.material === 'canvas' && v2.summaryCanvas ? v2.summaryCanvas : matWord;

      // Plate under the art. A pre-paid link shows only who it is for: the finish drawn there is
      // the default, not what they bought.
      if (plaque) {
        var who = customerName ? customerName + '\u2019s ' + (carName || 'artwork') : carName;
        plaque.textContent = '';
        ['is-l', 'is-r'].forEach(function (side) {
          var screw = document.createElement('span');
          screw.className = 'apv2-screw ' + side;
          screw.setAttribute('aria-hidden', 'true');
          plaque.appendChild(screw);
        });
        if (who) {
          var l1 = document.createElement('span');
          l1.className = 'apv2-plaque-who';
          l1.textContent = who;
          plaque.appendChild(l1);
        }
        if (!isPaid) {
          var styleWord = V2_STYLE_WORD[String(param('s', 'style') || '').toLowerCase()] || '';
          var l2 = document.createElement('span');
          l2.className = 'apv2-plaque-spec';
          // The plate says just the button word ("Canvas", Wes 2026-10-18); the order summary keeps summaryWord.
          l2.textContent = [styleWord, matWord, frameBit, sizeShort].filter(Boolean).join(' - ');
          plaque.appendChild(l2);
        }
        // Nothing to say (a paid link with no name or car): no empty brass stub with two screws.
        plaque.hidden = !plaque.querySelector('.apv2-plaque-who, .apv2-plaque-spec');
      }

      var headingEl = root.querySelector('[data-v2-heading]');
      if (headingEl) {
        headingEl.textContent = customerName
          ? customerName + '\u2019s ' + (carName ? carName + ' ' : '') + 'Order'
          : v2.headingFallback || 'Your Order';
      }

      var selEl = root.querySelector('[data-v2-selection]');
      if (selEl) selEl.textContent = [summaryWord, frameBit, sizeShort].filter(Boolean).join(' - ');


      // The summary INHERITS the descriptions shown under the options (one source of truth). For canvas
      // the product description ends in "ready to hang", which gets its own line, so the trailing phrase
      // is dropped from the inherited text rather than saying it twice.
      var productDesc = v2Note(v2FinishBtn(L, a.material));
      if (a.material === 'canvas') {
        productDesc = productDesc.replace(/\s*(?:[-\u2013\u2014,]\s*)?ready to hang\.?\s*$/i, '').trim();
      }
      var rows = [v2.checkArtwork, productDesc];
      if (a.framed && frameName) rows.push(frameDesc);
      // Every canvas and every framed print is ready to hang; only a loose, unframed print is not.
      if (a.material === 'canvas' || a.framed) rows.push(v2.checkReady);
      rows.push(v2.checkShipping);
      rows = rows.filter(Boolean);
      var list = root.querySelector('[data-v2-checks]');
      var sig = rows.join('|');
      if (list && list.getAttribute('data-sig') !== sig) {
        list.setAttribute('data-sig', sig);
        list.textContent = '';
        rows.forEach(function (text) {
          var li = document.createElement('li');
          var tick = document.createElement('span');
          tick.className = 'apv2-tick';
          tick.setAttribute('aria-hidden', 'true');
          var label = document.createElement('span');
          label.textContent = text;
          li.appendChild(tick);
          li.appendChild(label);
          list.appendChild(li);
        });
      }
      // The plate text may have wrapped differently; keep the docked compensation exact.
      if (v2DockState) v2DockState.measure();
    }

    // ── One size/material/frame configurator ─────────────────────
    // scopeEl is either root itself (preview mode's single .apv-config) or
    // one .apv-vehicle card (order mode, one instance per vehicle).
    // isPrimary means this instance also drives the shared stage — the live
    // frame/mat drawing, the room-view art sizing, and the plaque caption.
    // Exactly one instance is ever primary: the preview-mode picker, or
    // order mode's vehicle 0. Every other order-mode vehicle just prices
    // itself and reports back to updateOrderTotals().
    function createConfigController(scopeEl, isPrimary) {
      var sizeBtns = Array.prototype.slice.call(scopeEl.querySelectorAll('[data-size]'));
      var finishBtns = Array.prototype.slice.call(scopeEl.querySelectorAll('[data-finish]'));
      var colourBtns = Array.prototype.slice.call(scopeEl.querySelectorAll('[data-frame]'));
      var colourWrap = scopeEl.querySelector('[data-colourwrap]');
      var variantInput = scopeEl.querySelector('[data-variant-input]');

      // The variant lookup still runs on (size, material, frame) — that is
      // what maps to a Gelato SKU and must not change. Only the way the
      // customer is ASKED has changed: one "finish" choice now sets both
      // material and frame, and frame colour is a follow-up detail.
      var materials = ['print', 'canvas'];

      // frames[0] is always 'none'. The colour buttons cover the framed
      // options only — "unframed" is expressed by picking an unframed
      // finish, not by a No-frame card — so colourBtns[i] is frames[i + 1].
      var frames = ['none'].concat(
        colourBtns.map(function (b) {
          return b.getAttribute('data-frame');
        })
      );

      // Cheapest size is the default (2026-09-09 audit) -- was `size: 1`
      // (Medium), matching the original design spec, but that meant the
      // order form's first total never matched the site's advertised
      // "from" price. Combined with defaultFinishMaterial now defaulting
      // to the cheapest finish too, index 0 here is what makes the form
      // actually open on the lowest real price.
      var state = {
        size: 0,
        material: materials.indexOf(CFG.defaultFinishMaterial) === -1 ? 0 : materials.indexOf(CFG.defaultFinishMaterial),
        frame: 0,
        companion: false,
        verdict: null
      };

      function colourBtnFor(frameIdx) {
        return frameIdx > 0 ? colourBtns[frameIdx - 1] : null;
      }

      // The finish key a (material, frame) pair adds up to, and the reverse.
      function finishKey(materialKey, framed) {
        return (framed ? 'framed-' : '') + materialKey;
      }
      function currentFinishKey() {
        return finishKey(materials[state.material], state.frame !== 0);
      }

      function sizeValue(i) {
        var b = sizeBtns[i];
        return b ? b.getAttribute('data-option-value') : '';
      }

      // Does this exact combination exist as a buyable variant?
      function variantAt(sizeIdx, materialKey, frameKey) {
        return findVariant(sizeValue(sizeIdx), materialKey, frameKey);
      }

      // The frame colour a finish should use. Keeps the current colour when
      // it exists on the new material, otherwise falls to the first that
      // does — switching Framed Print to Framed Canvas while White is
      // selected has to land somewhere, and canvas has no white frame.
      function colourForMaterial(materialKey, preferredFrameIdx) {
        if (preferredFrameIdx > 0 && variantAt(state.size, materialKey, frames[preferredFrameIdx])) {
          return preferredFrameIdx;
        }
        for (var i = 1; i < frames.length; i++) {
          for (var sz = 0; sz < sizeBtns.length; sz++) {
            if (variantAt(sz, materialKey, frames[i])) return i;
          }
        }
        return 0;
      }

      // Cheapest real price for a finish, across every size it offers —
      // the "from $189" on its card.
      function finishFrom(materialKey, framed) {
        var best = null;
        var frameIdxs = [];
        if (framed) {
          for (var f = 1; f < frames.length; f++) frameIdxs.push(f);
        } else {
          frameIdxs.push(0);
        }
        for (var i = 0; i < sizeBtns.length; i++) {
          for (var k = 0; k < frameIdxs.length; k++) {
            var v = variantAt(i, materialKey, frames[frameIdxs[k]]);
            if (v && (best === null || v.price < best)) best = v.price;
          }
        }
        return best;
      }

      // Applies a finish card: sets material, and turns the frame on or off.
      function applyFinish(materialKey, framed) {
        state.material = materials.indexOf(materialKey);
        if (state.material === -1) state.material = 0;
        state.frame = framed ? colourForMaterial(materialKey, state.frame) : 0;
        // The chosen size may not exist in the new finish (paper has no
        // 20x30). Move to the nearest one that does rather than leaving the
        // customer on a size the finish cannot make.
        if (!variantAt(state.size, materials[state.material], frames[state.frame])) {
          var nearest = -1;
          var bestDist = Infinity;
          for (var i = 0; i < sizeBtns.length; i++) {
            if (!variantAt(i, materials[state.material], frames[state.frame])) continue;
            var d = Math.abs(i - state.size);
            if (d < bestDist) { bestDist = d; nearest = i; }
          }
          if (nearest !== -1) state.size = nearest;
        }
      }

      function render() {
        var material = materials[state.material];
        var frame = frames[state.frame];
        var current = findVariant(sizeValue(state.size), material, frame);
        var isPrint = material === "print";
        var framed = frame !== "none";

        // -- Finish cards ---------------------------------------
        var activeFinish = currentFinishKey();
        finishBtns.forEach(function (b) {
          var m = b.getAttribute("data-finish-material");
          var f = b.getAttribute("data-finish-framed") === "true";
          var from = finishFrom(m, f);
          // A finish with no variants at all (Wes retiring a whole line)
          // removes itself rather than sitting there unbuyable.
          b.hidden = from === null;
          if (from === null) return;
          var on = b.getAttribute("data-finish") === activeFinish;
          b.classList.toggle("is-on", on);
          b.setAttribute("aria-checked", on ? "true" : "false");
          b.setAttribute("tabindex", on ? "0" : "-1");
          var fromEl = b.querySelector("[data-finish-from]");
          if (fromEl) fromEl.textContent = money(from);
        });

        // -- Frame colour ---------------------------------------
        if (colourWrap) colourWrap.hidden = !framed;
        colourBtns.forEach(function (b, i) {
          var frameIdx = i + 1;
          // Shown only where the colour actually exists on this material at
          // some size — canvas has no white frame, so White is absent
          // rather than greyed out inviting a click that cannot work.
          var exists = false;
          for (var sz = 0; sz < sizeBtns.length && !exists; sz++) {
            if (variantAt(sz, material, frames[frameIdx])) exists = true;
          }
          b.hidden = !exists;
          if (!exists) return;
          var on = state.frame === frameIdx;
          b.classList.toggle("is-on", on);
          b.setAttribute("aria-checked", on ? "true" : "false");
          b.setAttribute("tabindex", on ? "0" : "-1");

          // Corner-crop thumbnail, matched to the current material —
          // borrowing the other material's shot if this one has none yet
          // (white has no canvas photo), so the thumb is never blank.
          var thumbEl = b.querySelector("[data-frame-thumb]");
          if (thumbEl) {
            var otherMaterial = material === "print" ? "canvas" : "print";
            var thumbUrl =
              b.getAttribute("data-frame-corner-" + material) ||
              b.getAttribute("data-frame-corner-" + otherMaterial);
            if (thumbUrl && thumbEl.getAttribute("src") !== thumbUrl) {
              thumbEl.setAttribute("src", thumbUrl);
            }
          }
        });

        // -- Size cards -----------------------------------------
        // Priced inside the chosen finish only, so the ladder is always
        // monotonic, and a size the finish cannot make is absent rather
        // than dimmed or silently repriced off another material.
        sizeBtns.forEach(function (b, i) {
          var v = variantAt(i, material, frame);
          b.hidden = !v;
          if (!v) return;
          var on = state.size === i;
          b.classList.toggle("is-on", on);
          b.setAttribute("aria-checked", on ? "true" : "false");
          b.setAttribute("tabindex", on ? "0" : "-1");
          renderCardPrice(b.querySelector("[data-price]"), b.querySelector("[data-size-save]"), v);
        });
        // Span the last VISIBLE card across both mobile columns when an odd
        // count of them would otherwise strand it (see the CSS comment on
        // .apv-sizes .apv-card.apv-span-full) -- computed from the actual
        // hidden state just set above, not from DOM position, since a
        // finish that can't make one size (paper has no 20x30) shifts which
        // card is really last without changing the total child count.
        var visibleSizeBtns = sizeBtns.filter(function (b) { return !b.hidden; });
        sizeBtns.forEach(function (b) { b.classList.remove("apv-span-full"); });
        if (visibleSizeBtns.length % 2 === 1) {
          visibleSizeBtns[visibleSizeBtns.length - 1].classList.add("apv-span-full");
        }

        var sizeTitleEl = sizeBtns[state.size]
          ? sizeBtns[state.size].querySelector(".apv-card-title")
          : null;
        var sizeLabel = sizeTitleEl ? sizeTitleEl.textContent.trim() : "";
        var activeFinishBtn = null;
        finishBtns.forEach(function (b) {
          if (b.getAttribute("data-finish") === activeFinish) activeFinishBtn = b;
        });
        var matLabelEl = activeFinishBtn ? activeFinishBtn.querySelector(".apv-card-title") : null;
        var matLabel = matLabelEl ? matLabelEl.textContent.trim() : "";
        var colourBtn = colourBtnFor(state.frame);
        var frameLabelEl = colourBtn ? colourBtn.querySelector(".apv-colour-name") : null;
        var frameLabel = frameLabelEl ? frameLabelEl.textContent.trim() : "";

        if (isPrimary) {
          // Frame and mat drawn live on the artwork — unless the selected
          // frame swatch carries a real photographed-frame image for the
          // current material (data-frame-photo-print / -canvas — print and
          // canvas frames are physically different mouldings, so each gets
          // its own photo and its own measured opening rect), in which case
          // that PNG's own moulding + baked-in shadow replaces the flat
          // data-hex band entirely. Every photo has a different canvas size
          // and opening, so the rect (left/top/w/h as % of the photo, plus
          // its own aspect ratio) travels with the photo's JSON blob rather
          // than living in the stylesheet — see the .has-frame-photo rules
          // for what stays static vs. what gets set inline below.
          var hex = colourBtn ? colourBtn.getAttribute('data-hex') : null;
          var framePhotoData = framed
            ? framePhotoFor(colourBtn, isPrint ? 'print' : 'canvas')
            : null;
          var framePhotoUrl = framePhotoData ? framePhotoData.url : null;
          if (frameband) frameband.classList.toggle('has-frame-photo', !!framePhotoUrl);
          if (framePhoto) {
            framePhoto.hidden = !framePhotoUrl;
            if (framePhotoUrl && framePhoto.getAttribute('src') !== framePhotoUrl) {
              framePhoto.setAttribute('src', framePhotoUrl);
            }
          }
          if (frameband) {
            frameband.style.aspectRatio = framePhotoData ? String(framePhotoData.ratio) : '';
            // Fallback for browsers without aspect-ratio (see the @supports block in the stylesheet).
            var ratioParts = framePhotoData ? String(framePhotoData.ratio).split("/") : [];
            var ratioNum = parseFloat(ratioParts[0]) / (ratioParts.length > 1 ? parseFloat(ratioParts[1]) : 1);
            if (ratioNum > 0) frameband.style.setProperty('--apv-frame-pad', (100 / ratioNum).toFixed(3) + '%');
            else frameband.style.removeProperty('--apv-frame-pad');
          }
          if (!framePhotoUrl && frameband) {
            frameband.style.padding = framed ? '16px' : '0';
            frameband.style.background = framed && hex ? hex : 'transparent';
            // Unframed print: flat against the wall, no drop shadow of its
            // own. Unframed canvas: no shadow here either — its depth comes
            // entirely from .apv-mat.is-canvas-wrap's own box-shadow below,
            // which already includes an outer drop shadow layer.
            frameband.style.boxShadow = framed ? '0 26px 62px rgba(0,0,0,.66)' : 'none';
          }
          if (mat) {
            if (framePhotoData) {
              mat.style.left = framePhotoData.left + '%';
              mat.style.top = framePhotoData.top + '%';
              mat.style.width = framePhotoData.w + '%';
              mat.style.height = framePhotoData.h + '%';
            } else {
              mat.style.left = mat.style.top = mat.style.width = mat.style.height = '';
            }
            // Only a fine art print gets a mat; canvas is a gallery wrap.
            // A photographed frame has no separate mat layer of its own yet,
            // so it stays flush with the art until one exists.
            var matted = isPrint && !framePhotoUrl;
            // No frame, no mat: the only combination left over is an
            // unframed canvas, which should read as a gallery-wrapped
            // canvas hanging directly on the wall rather than a flat photo
            // — see .apv-mat.is-canvas-wrap::after for the bevel that
            // sells it (a ::after overlay, not the mat's own box-shadow,
            // so it paints on top of the art instead of hiding behind it —
            // the art still fills the mat edge-to-edge either way).
            var canvasWrap = !framed && !isPrint;
            mat.classList.toggle('is-canvas-wrap', canvasWrap);
            mat.style.padding = matted ? '5px' : '0';
            mat.style.background = matted ? '#FFFFFF' : 'transparent';
          }

          // Room view scales the art by the chosen size so Small vs Large reads.
          if (artwrap) {
            var roomMax = sizeBtns[state.size]
              ? sizeBtns[state.size].getAttribute('data-room-max')
              : '580px';
            artwrap.style.setProperty('--apv-artmax', roomState.room ? roomMax : '900px');
          }

          // The redesigned page writes its own two-line plate in syncV2().
          if (plaque && !v2) {
            plaque.textContent = sizeLabel + ' · ' + matLabel + (framed ? ' · ' + frameLabel : '');
          }

          // Never on the smallest size — a small print beside a small print
          // is not an upgrade. And in order mode, only on a single-vehicle
          // order: "a poster of this same artwork" has no answer once there
          // are two cars on the page, and those orders have the multi-piece
          // saving as their upsell instead.
          var companionEligible =
            companionSellable() &&
            state.size !== 0 &&
            (!isOrder || vehicleControllers.length === 1);
          if (companionBtn) {
            companionBtn.hidden = !companionEligible;
            if (!companionEligible) state.companion = false;
            companionBtn.classList.toggle('is-on', state.companion);
            companionBtn.setAttribute('aria-pressed', state.companion ? 'true' : 'false');
            if (companionMark) companionMark.textContent = state.companion ? '✓' : '';
            if (companionPriceEl) companionPriceEl.textContent = '+ ' + money(companionPrice());
          }
        }

        if (variantInput) variantInput.value = current ? String(current.id) : '';

        // Preview mode is a single instance with nothing to sum across, so
        // it writes the shared total/summary/buy-button directly here —
        // the same thing this function always did before order mode had
        // more than one of these. Order mode's instances skip this; the
        // grand total across every vehicle is updateOrderTotals()'s job.
        if (isPrimary && !isOrder) {
          var companionOn = state.companion && CFG.companion.enabled && state.size !== 0;
          var total = current ? current.price : 0;
          // The companion print has no compare-at of its own (it is a
          // settings price, not a variant), so it lands on both sides of
          // the comparison and never invents a saving.
          var wasTotal = listPriceOf(current);
          if (companionOn) {
            total += companionPrice();
            wasTotal += companionPrice();
          }
          var previewBreakdown = computeBreakdown();
          renderDupe(current, previewBreakdown ? previewBreakdown.subtotal : '');
          var previewDupe = dupeOn
            ? dupeItem(current, previewBreakdown ? previewBreakdown.subtotal : '')
            : null;
          if (previewDupe) {
            total += previewDupe.price;
            wasTotal += previewDupe.list;
          }

          applyTotals(total, wasTotal, !!current);

          var parts = [sizeLabel, matLabel, framed ? frameLabel + ' frame' : 'No frame'];
          if (companionOn) parts.push('+ small print');
          var summary = parts.join(' · ');
          // textContent clears any previous appendDupeSummary output too,
          // which is exactly what's wanted -- it gets rebuilt fresh right
          // after, matching order mode's "whole thing rebuilds every render".
          if (summaryEl) {
            // No suffix set: no trailing " · " (2026-10-04, it was left dangling).
            var suffix = (CFG.summarySuffix || '').trim();
            summaryEl.textContent = suffix ? summary + ' · ' + suffix : summary;
            appendDupeSummary(summaryEl, previewDupe);
          }
          buyBtns.forEach(function (b) {
            b.disabled = !current;
          });
          if (unavailableEl) unavailableEl.hidden = !!current;
        }

        if (isPrimary && !isOrder) syncV2();
        if (isOrder && v2o) syncV2Pick(scopeEl);

        return { variant: current, price: current ? current.price : 0 };
      }

      function cardLabel(btn) {
        var el = btn && btn.querySelector('.apv-card-title');
        return el ? el.textContent.trim() : '';
      }

      // Reads a frame swatch's data-frame-photo-print / -canvas JSON blob
      // (url + opening rect % + aspect ratio — see the markup comment
      // above data-frame-photo-img) for the compositing path only.
      // Deliberately does NOT fall back to the other material the way the
      // corner-thumbnail lookup above does: compositing a print frame's
      // photo onto a canvas order would misrepresent the physical
      // product, so a missing photo here correctly falls back to the flat
      // data-hex band instead (null return, handled by the caller).
      function framePhotoFor(btn, materialKey) {
        if (!btn) return null;
        var attr = btn.getAttribute('data-frame-photo-' + materialKey);
        if (!attr) return null;
        try {
          return JSON.parse(attr);
        } catch (e) {
          return null;
        }
      }

      // What this piece is, in one line, for the order panel: "16 x 24\" ·
      // Framed Canvas · Black". It replaced an itemised SIZE / MATERIAL /
      // FRAME breakdown whose rows mostly read "+$0" — three lines of
      // arithmetic noise to say what one line says plainly.
      function computeBreakdown() {
        var current = findVariant(sizeValue(state.size), materials[state.material], frames[state.frame]);
        if (!current) return null;

        var titleEl = sizeBtns[state.size] ? sizeBtns[state.size].querySelector(".apv-card-title") : null;
        var parts = [titleEl ? titleEl.textContent.trim() : ""];

        var activeFinish = currentFinishKey();
        var finishTitle = "";
        finishBtns.forEach(function (b) {
          if (b.getAttribute("data-finish") !== activeFinish) return;
          var t = b.querySelector(".apv-card-title");
          if (t) finishTitle = t.textContent.trim();
        });
        if (finishTitle) parts.push(finishTitle);

        var cb = colourBtnFor(state.frame);
        var colourName = cb ? cb.querySelector(".apv-colour-name") : null;
        if (colourName) parts.push(colourName.textContent.trim());

        return {
          subtotal: parts.filter(Boolean).join(" \u00b7 "),
          total: current.price,
          listTotal: listPriceOf(current)
        };
      }

      // Nothing to reconcile any more. Picking the finish first means the
      // pickers only ever offer combinations that exist: sizes a finish
      // cannot make are not rendered, colours a material lacks are not
      // rendered, and applyFinish() moves the size if a finish change
      // strands it. The old cheapestAt/resolveForSize/reconcile trio that
      // rescued dead ends is gone with the dead ends themselves.
      wireGroup(sizeBtns, function (i) {
        state.size = i;
        render();
        if (isOrder) updateOrderTotals();
      });

      wireGroup(finishBtns, function (i) {
        var b = finishBtns[i];
        applyFinish(b.getAttribute("data-finish-material"), b.getAttribute("data-finish-framed") === "true");
        render();
        if (isOrder) updateOrderTotals();
      });

      wireGroup(colourBtns, function (i) {
        state.frame = i + 1;
        render();
        if (isOrder) updateOrderTotals();
      });

      // Settle the opening selection against what Gelato actually sells:
      // the default finish comes from a setting, and the default size from
      // block order, neither of which knows the catalogue.
      // ?f= (Airtable Product Interest, 2026-10-16): open on the finish picked on the free-preview form.
      var PF = { print: ["print"], canvas: ["canvas"], framed_print: ["print", 1], framed_canvas: ["canvas", 1] };
      var pf = !isOrder && PF.hasOwnProperty(param("f")) && PF[param("f")];
      if (pf && finishFrom(pf[0], !!pf[1]) === null) pf = 0;
      applyFinish(
        pf ? pf[0] : CFG.defaultFinishMaterial === "print" ? "print" : "canvas",
        pf ? !!pf[1] : CFG.defaultFinishFramed === true
      );

      // Simplified order form: open on the size set in "Size it opens on" (the finish and frame defaults come from
      // default_finish_material / default_finish_framed above), as long as that finish makes it.
      if (v2o && v2o.defaultSize) {
        var wantSize = v2NormSize(v2o.defaultSize);
        sizeBtns.forEach(function (b, i) {
          var t = b.querySelector('.apv-card-title');
          if (t && v2NormSize(t.textContent) === wantSize && variantAt(i, materials[state.material], frames[state.frame])) {
            state.size = i;
          }
        });
      }

      // Art style (order mode only) — drives which Flux prompt is used.
      var artStyleBtns = Array.prototype.slice.call(scopeEl.querySelectorAll('[data-artstyle]'));
      var artStyleInput = scopeEl.querySelector('[data-artstyle-input]');
      if (artStyleBtns.length && artStyleInput) {
        wireGroup(artStyleBtns, function (i) {
          artStyleBtns.forEach(function (b, n) {
            var on = n === i;
            b.classList.toggle('is-on', on);
            b.setAttribute('aria-checked', on ? 'true' : 'false');
            b.setAttribute('tabindex', on ? '0' : '-1');
          });
          artStyleInput.value = artStyleBtns[i].getAttribute('data-artstyle') || '';
        });
      }

      // ── Photo upload ─────────────────────────────────────────
      // Only the primary instance feeds the shared stage (artEl) — every
      // other vehicle just gets its own thumbnail in its own card.
      var photoInput = scopeEl.querySelector('[data-photo]');
      var uploadBox = scopeEl.querySelector('[data-upload]');
      var uploadText = scopeEl.querySelector('[data-upload-text]');
      var uploadHint = scopeEl.querySelector('[data-upload-hint]');
      var uploadThumb = scopeEl.querySelector('[data-upload-thumb]');
      var uploadError = scopeEl.querySelector('[data-upload-error]');
      var uploadTextInit = uploadText ? uploadText.textContent : '';
      var uploadHintInit = uploadHint ? uploadHint.textContent : '';

      function uploadFail(msg) {
        if (!uploadError) return;
        uploadError.textContent = msg;
        uploadError.hidden = false;
      }

      if (photoInput) {
        photoInput.addEventListener('change', function () {
          if (uploadError) uploadError.hidden = true;
          var file = photoInput.files && photoInput.files[0];
          if (!file) return;

          // Shopify rejects anything over its own cap at checkout, which would
          // lose the customer's work after they have filled everything in.
          var maxBytes = (CFG.maxUploadMb || 20) * 1024 * 1024;
          if (file.size > maxBytes) {
            photoInput.value = '';
            if (uploadBox) uploadBox.classList.remove('is-filled');
            uploadFail(CFG.uploadError.replace('[max]', String(CFG.maxUploadMb || 20)));
            return;
          }

          if (uploadBox) uploadBox.classList.add('is-filled');
          // Not file.name: Facebook's in-app browser names photos "inbound123..." (see preview-flow).
          if (uploadText) uploadText.textContent = 'Photo added';
          if (uploadHint) uploadHint.textContent = 'Tap to choose a different photo';

          var reader = new FileReader();
          reader.onload = function (e) {
            if (uploadThumb) {
              uploadThumb.src = e.target.result;
              uploadThumb.hidden = false;
            }
            if (isPrimary && artEl) {
              artEl.src = e.target.result;
              artEl.hidden = false;
              root.classList.remove('is-awaiting-photo');
              if (watermarkEl && CFG.orderV2) watermarkEl.textContent = CFG.orderPhotoNote || watermarkText;
            }
          };
          reader.readAsDataURL(file);
        });

        // Simplified order form: "Remove" on the photo line puts the step back to its empty state. For the
        // primary vehicle that also takes the framed preview away again (nothing real to show without a photo).
        var removeBtn = scopeEl.querySelector('[data-photo-remove]');
        if (removeBtn) {
          removeBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            photoInput.value = '';
            if (uploadBox) uploadBox.classList.remove('is-filled');
            if (uploadText) uploadText.textContent = uploadTextInit;
            if (uploadHint) uploadHint.textContent = uploadHintInit;
            if (uploadThumb) {
              uploadThumb.removeAttribute('src');
              uploadThumb.hidden = true;
            }
            if (uploadError) uploadError.hidden = true;
            if (isPrimary && artEl) {
              artEl.removeAttribute('src');
              root.classList.add('is-awaiting-photo');
            }
          });
        }

        if (uploadBox) {
          ['dragenter', 'dragover'].forEach(function (evt) {
            uploadBox.addEventListener(evt, function (e) {
              e.preventDefault();
              uploadBox.classList.add('is-over');
            });
          });
          ['dragleave', 'drop'].forEach(function (evt) {
            uploadBox.addEventListener(evt, function () {
              uploadBox.classList.remove('is-over');
            });
          });
          uploadBox.addEventListener('drop', function (e) {
            e.preventDefault();
            if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
              photoInput.files = e.dataTransfer.files;
              photoInput.dispatchEvent(new Event('change'));
            }
          });
        }
      }

      return {
        el: scopeEl,
        state: state,
        render: render,
        computeBreakdown: computeBreakdown,
        hasPhoto: function () {
          return !!(photoInput && photoInput.files && photoInput.files.length);
        },
        photoInput: photoInput,
        uploadBox: uploadBox,
        uploadFail: uploadFail
      };
    }

    // ── Instantiate: one controller for preview mode, one per vehicle
    // for order mode ─────────────────────────────────────────────
    var primaryController = null;
    var vehicleControllers = [];

    function signedMoney(cents) {
      return (cents < 0 ? '−' : '+') + money(Math.abs(cents));
    }

    // The one place the total, its struck-through was-price and the savings
    // line are written. `listTotal` is what the order would have cost at
    // full price; when it isn't higher than what's actually charged, every
    // sale element stays hidden and the buy box looks exactly as it did
    // before compare-at prices existed.
    function applyTotals(total, listTotal, valid) {
      // Extra % off the sale price; the compare-at stays struck through so "You save" is the whole saving.
      if (valid && offerOn()) {
        total = offerApi().apply(total);
        offerApi().total(listTotal, total);
      }
      var totalText = valid ? money(total) : '—';
      if (totalEl) totalEl.textContent = totalText;
      var stickyPrice = root.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = totalText;

      var saved = valid && listTotal > total ? listTotal - total : 0;
      if (totalWasEl) {
        totalWasEl.textContent = saved ? money(listTotal) : '';
        totalWasEl.hidden = !saved;
      }

      if (saveEl) {
        if (saved) {
          // Rounded off the pre-discount figure, so "save $50 (17%)" always
          // divides back out to the two numbers printed either side of it.
          var pct = Math.round((saved / listTotal) * 100);
          saveEl.textContent = CFG.saveLabel + ' ' + money(saved) + ' (' + pct + '%)';
          saveEl.hidden = false;
        } else {
          saveEl.textContent = '';
          saveEl.hidden = true;
        }
      }
    }

    // What the multi-piece bundle takes off an order of `count` pieces
    // subtotalling `subtotal`. Returns 0 whenever the offer is off, has no
    // percentage set, or the order is short of the minimum — so the summary
    // and the total can both just ask, without repeating the conditions.
    // Whether the companion print is genuinely part of this order. The
    // button's own state is not enough on its own — the size can change
    // under it, and in order mode a second vehicle can appear — so the
    // total, the summary line and the cart fields all ask here rather than
    // each re-deriving the same three conditions slightly differently.
    // Whether the companion can be sold at all right now. When it is a
    // variant of THIS product — which it is, it's the same 12 × 18″ poster —
    // its availability is known here, so a retired or out-of-stock companion
    // hides itself instead of failing at checkout. A companion living on some
    // other product can't be checked from here and is trusted.
    function companionSellable() {
      if (!CFG.companion.enabled || !CFG.companion.variantId) return false;
      var v = companionVariant();
      return v ? v.available : true;
    }

    function companionActive() {
      if (!companionSellable() || !primaryController) return false;
      if (primaryController.state.size === 0) return false;
      if (isOrder && vehicleControllers.length !== 1) return false;
      return !!primaryController.state.companion;
    }

    // Points the companion's cart fields at the index straight after the
    // last vehicle and switches them on or off. Disabled fields are not
    // submitted at all, so an unselected companion leaves items[] exactly
    // as it was — no gap, nothing for Shopify's bracket-array parsing to
    // trip over. Order mode only; preview mode adds its companion through
    // the Ajax cart instead (see the buy-button handler).
    function syncCompanionFields(on) {
      if (!companionIdInput || !companionQtyInput) return;
      var idx = vehicleControllers.length;
      companionIdInput.name = 'items[' + idx + '][id]';
      companionQtyInput.name = 'items[' + idx + '][quantity]';
      if (companionTagInput) companionTagInput.name = 'items[' + idx + '][properties][' + COMPANION_KEY + ']';
      companionIdInput.value = CFG.companion.variantId || '';
      // No variant id means the upsell was never finished being set up in
      // Shopify; submitting an empty id would fail the whole add-to-cart
      // and take the customer's real order down with it.
      var usable = on && !!CFG.companion.variantId;
      companionIdInput.disabled = !usable;
      companionQtyInput.disabled = !usable;
      if (companionTagInput) companionTagInput.disabled = !usable;
    }

    // Cart fields for the selected extra prints, rebuilt from scratch on
    // every change — no stale input can survive a deselect, which is the
    // failure mode that would silently bill someone for a print they
    // unticked. They take the indices straight after the vehicles (and the
    // companion, if that older single upsell is somehow also in play), so
    // items[] stays contiguous for Shopify's bracket-array parsing.
    //
    // Each carries the same `Companion print` property as the companion:
    // these ARE companion prints, and the pipeline's ingest excludes that
    // key so none of them opens a phantom commission in Airtable.
    // What the multi-piece bundle takes off an order of `count` pieces
    // subtotalling `subtotal`. Returns 0 whenever the offer is off, has no
    // percentage set, or the order is short of the minimum — so the summary
    // and the total can both just ask, without repeating the conditions.
    function bundleDiscount(subtotal, count) {
      var b = CFG.bundle;
      if (!b || !b.enabled) return 0;
      var pct = Number(b.percent) || 0;
      var min = Number(b.minItems) || 0;
      if (pct <= 0 || count < min) return 0;
      return Math.round((subtotal * pct) / 100);
    }

    // The order, as a receipt: one plain line per piece, then whatever the
    // order as a whole picks up. It used to itemise every axis — SIZE /
    // MATERIAL / FRAME, each with its own "+$0" row — which is three lines
    // of arithmetic to say what one line says: "16 x 24\" Framed Canvas,
    // $249". Customers do not audit a configurator, they check the thing
    // they picked and the number they will pay.
    function renderOrderSummary(breakdowns, bundleOff, companionOn, dupe) {
      if (!summaryEl) return;
      summaryEl.textContent = "";
      var multi = breakdowns.length > 1;

      function row(label, valueText, cls, note) {
        var rowEl = document.createElement("div");
        rowEl.className = "apv-summary-row" + (cls ? " " + cls : "");

        var labelEl = document.createElement("span");
        labelEl.className = "apv-summary-row-label";
        labelEl.textContent = label;

        var priceEl = document.createElement("span");
        priceEl.className = "apv-summary-row-price";
        priceEl.textContent = valueText;

        rowEl.appendChild(labelEl);
        rowEl.appendChild(priceEl);
        summaryEl.appendChild(rowEl);

        if (note) {
          var noteEl = document.createElement("div");
          noteEl.className = "apv-summary-bundle-note";
          noteEl.textContent = note;
          summaryEl.appendChild(noteEl);
        }
      }

      // Order form with the simplified picker: the selected product's detail lines, ticked, under its piece.
      function appendPieceBullets(vehEl) {
        var list = [];
        try {
          list = JSON.parse(vehEl.getAttribute('data-bullets') || '[]');
        } catch (err) {
          list = [];
        }
        // Custom artwork by Wes first, then this product's own detail lines (product, frame, ready to hang).
        if (CFG.v2 && CFG.v2.checkArtwork) list.unshift(CFG.v2.checkArtwork);
        if (!list.length) return;
        var ul = document.createElement('ul');
        ul.className = 'apv2-checks apv-piece-checks';
        list.forEach(function (text) {
          var li = document.createElement('li');
          var tick = document.createElement('span');
          tick.className = 'apv2-tick';
          tick.setAttribute('aria-hidden', 'true');
          var label = document.createElement('span');
          label.textContent = text;
          li.appendChild(tick);
          li.appendChild(label);
          ul.appendChild(li);
        });
        summaryEl.appendChild(ul);
      }

      breakdowns.forEach(function (b, vi) {
        if (!b) {
          row(CFG.soonLabel, "", "apv-summary-piece");
          return;
        }
        // The vehicle number only earns its place once there is more than
        // one — on the single-piece order that is most of them, "Vehicle 1"
        // is a label for a distinction the customer is not making.
        var label = multi
          ? (CFG.vehicleLabel || "Vehicle") + " " + (vi + 1) + " \u2014 " + b.subtotal
          : b.subtotal;
        row(label, money(b.total), "apv-summary-piece");
        if (v2o && vehicleControllers[vi]) appendPieceBullets(vehicleControllers[vi].el);
      });

      // The "second copy", directly under the piece it duplicates -- dupe is
      // only ever eligible on a single-vehicle order (see dupeEligible), so
      // "right after the vehicle loop" and "right after the first piece"
      // are the same position; no extra bookkeeping needed to find it.
      // Built by appendDupeSummary, shared with preview mode's own summary
      // line below -- see that function's own comment.
      appendDupeSummary(summaryEl, dupe);

      // Simplified order form: the shipping line closes the tick list (artwork -> product / frame -> shipping).
      if (v2o && CFG.orderShip && CFG.orderShip.label && breakdowns.some(Boolean)) {
        var shipUl = document.createElement('ul');
        shipUl.className = 'apv2-checks apv-piece-checks apv-ship-checks';
        var shipLi = document.createElement('li');
        var shipTick = document.createElement('span');
        shipTick.className = 'apv2-tick';
        shipTick.setAttribute('aria-hidden', 'true');
        var shipLabel = document.createElement('span');
        shipLabel.textContent = CFG.orderShip.label;
        if (CFG.orderShip.value) {
          var shipVal = document.createElement('b');
          shipVal.className = 'apv2-checkval';
          shipVal.textContent = CFG.orderShip.value;
          shipLabel.appendChild(shipVal);
        }
        shipLi.appendChild(shipTick);
        shipLi.appendChild(shipLabel);
        shipUl.appendChild(shipLi);
        summaryEl.appendChild(shipUl);
      }

      // Order-level lines, after every piece, so each reads as applying to
      // the order rather than to any one piece.
      if (companionOn) {
        row(CFG.companionSummaryLabel, signedMoney(companionPrice()), "apv-summary-extra");
      }

      // The note says where the money actually comes off. Line items go into
      // the cart at full price and Shopify's automatic discount takes this
      // off at checkout, so without it the cart looks, for a moment, like
      // the offer was forgotten.
      if (bundleOff > 0) {
        row(CFG.bundle.label, signedMoney(-bundleOff), "apv-summary-bundle", CFG.bundle.note);
      }
    }

    function updateOrderTotals() {
      var total = 0;
      var listTotal = 0;
      var allValid = true;
      // Vehicle 0's selection is what the "add a second one" offer mirrors,
      // so its variant and its one-line recap are captured on the way past.
      var primaryVariant = null;
      var primarySubtitle = '';
      var breakdowns = vehicleControllers.map(function (vc, i) {
        var result = vc.render();
        var breakdown = vc.computeBreakdown();
        if (i === 0) {
          primaryVariant = result ? result.variant : null;
          primarySubtitle = breakdown ? breakdown.subtotal : '';
        }
        if (!result.variant || !breakdown) {
          allValid = false;
          return null;
        }
        total += breakdown.total;
        listTotal += breakdown.listTotal;
        return breakdown;
      });

      var count = vehicleControllers.length;
      // Taken off the actual subtotal, not the list total, so a bundle
      // stacked on top of a markdown discounts the already-reduced price —
      // which is what Shopify's automatic discount will do at checkout, and
      // therefore the only figure that will still be true there.
      var bundleOff = allValid ? bundleDiscount(total, count) : 0;
      total -= bundleOff;

      // Added after the bundle, deliberately: the multi-piece saving is an
      // offer on commissions, and the companion is a different product that
      // a product-scoped Shopify discount would not touch either. It also
      // has no compare-at of its own — it is a settings price, not a variant
      // — so it lands on both sides of the comparison and never invents a
      // saving of its own.
      var companionOn = allValid && companionActive();
      if (companionOn) {
        total += companionPrice();
        listTotal += companionPrice();
      }
      syncCompanionFields(companionOn);

      // Extra prints go on last, after the bundle, for the same reason the
      // companion does: the multi-piece saving is an offer on commissions,
      // and these are already discounted in their own right. Their FULL
      // price goes into listTotal, so the 40% shows up in the one savings
      // figure under the total alongside any compare-at markdown.
      // The duplicate goes on last and mirrors vehicle 0. renderDupe runs
      // before the total is read because it is also what clears the tick
      // when the offer stops being eligible — a second vehicle appearing,
      // say — and an already-counted duplicate would otherwise survive in
      // the total after its checkbox had gone.
      renderDupe(primaryVariant, primarySubtitle);
      var dupe = allValid && dupeOn ? dupeItem(primaryVariant, primarySubtitle) : null;
      if (dupe) {
        total += dupe.price;
        listTotal += dupe.list;
      }
      syncDupeFields(vehicleControllers.length + (companionOn ? 1 : 0), dupe);

      applyTotals(total, listTotal, allValid);
      renderOrderSummary(breakdowns, bundleOff, companionOn, dupe);

      buyBtns.forEach(function (b) {
        b.disabled = !allValid;
      });
      if (unavailableEl) unavailableEl.hidden = allValid;
    }

    // Renumbers every vehicle's ids/for/name attributes to match its
    // current DOM position (0, 1, 2...) with no gaps — run after any
    // removal, since Shopify's items[N] cart syntax expects one, and a
    // gap (items[0], items[2]) is untested territory not worth risking.
    function renumberVehicleEl(el, i) {
      Array.prototype.slice.call(el.querySelectorAll('[id]')).forEach(function (node) {
        node.id = node.id.replace(/-\d+$/, '-' + i);
      });
      Array.prototype.slice.call(el.querySelectorAll('label[for]')).forEach(function (node) {
        node.setAttribute('for', node.getAttribute('for').replace(/-\d+$/, '-' + i));
      });
      Array.prototype.slice.call(el.querySelectorAll('[name]')).forEach(function (node) {
        node.name = node.name.replace(/^items\[\d+\]/, 'items[' + i + ']');
      });
      el.setAttribute('data-vehicle-index', String(i));
      var numEl = el.querySelector('[data-vehicle-num]');
      if (numEl) numEl.textContent = (CFG.vehicleLabel || 'Vehicle') + ' ' + (i + 1);
    }

    if (isOrder) {
      var vehiclesContainer = root.querySelector('[data-vehicles]');
      var vehicleTemplate = root.querySelector('[data-vehicle-template]');
      var addVehicleBtn = root.querySelector('[data-add-vehicle]');

      var vehicle0El = root.querySelector('[data-vehicle][data-vehicle-index="0"]');
      if (vehicle0El) {
        primaryController = createConfigController(vehicle0El, true);
        vehicleControllers.push(primaryController);
        v2Wire(vehicle0El);
      }

      function addVehicle() {
        if (!vehicleTemplate || !vehiclesContainer) return;
        var newIndex = vehicleControllers.length;
        var frag = vehicleTemplate.content.cloneNode(true);
        var wrap = document.createElement('div');
        wrap.appendChild(frag);
        // __IDX__ (0-based: ids, names) and __NUM__ (1-based: the "Vehicle N"
        // label) become the real numbers here — the template markup only
        // exists once in Liquid, which can't do this substitution itself
        // since __IDX__ is a placeholder string, not a real integer, when
        // Liquid renders the <template> (see apv-vehicle.liquid's comment).
        wrap.innerHTML = wrap.innerHTML
          .split('__IDX__').join(String(newIndex))
          .split('__NUM__').join(String(newIndex + 1));
        var vehicleEl = wrap.firstElementChild;
        vehiclesContainer.appendChild(vehicleEl);

        var controller = createConfigController(vehicleEl, false);
        vehicleControllers.push(controller);
        v2Wire(vehicleEl);

        var removeBtn = vehicleEl.querySelector('[data-remove-vehicle]');
        if (removeBtn) {
          removeBtn.addEventListener('click', function () {
            var idx = vehicleControllers.indexOf(controller);
            if (idx === -1) return;
            vehicleControllers.splice(idx, 1);
            vehicleEl.parentNode.removeChild(vehicleEl);
            Array.prototype.slice.call(vehiclesContainer.querySelectorAll('[data-vehicle]')).forEach(
              function (el, i) {
                renumberVehicleEl(el, i);
              }
            );
            updateOrderTotals();
          });
        }

        updateOrderTotals();
      }

      if (addVehicleBtn) addVehicleBtn.addEventListener('click', addVehicle);

      updateOrderTotals();
    } else {
      primaryController = createConfigController(root, true);
      primaryController.render();
      // Redesigned layout: wire its buttons, then open on the recommended size.
      v2Wire();
      v2DefaultSize();
      syncV2();
      v2DockInit();
      v2ZoomInit();
    }

    // ── Approval step ────────────────────────────────────────────
    // Standalone — "love it" / "request a change" is a preview-mode-only
    // decision, unrelated to any size/material/frame controller's own state.
    var verdict = { value: null };

    function renderVerdict() {
      var loved = verdict.value === 'love';
      var changing = verdict.value === 'change';
      if (loveBtn) {
        loveBtn.classList.toggle('is-on', loved);
        loveBtn.setAttribute('aria-pressed', loved ? 'true' : 'false');
      }
      if (loveMark) loveMark.textContent = loved ? '✓' : '';
      if (changeToggle) {
        changeToggle.classList.toggle('is-on', changing);
        changeToggle.setAttribute('aria-pressed', changing ? 'true' : 'false');
      }
      // On a pre-paid link the approve panel replaces the "pick your size
      // below" line, since there is nothing left to pick.
      if (lovedMsg) lovedMsg.hidden = !loved || isPaid;
      if (approveBox) approveBox.hidden = !(loved && isPaid);
      if (changeBox) changeBox.hidden = !changing;
    }

    // ── Approve & print (pre-paid links only) ────────────────────
    var approveBox = root.querySelector('[data-approve]');
    var approveSend = root.querySelector('[data-approve-send]');
    var approveError = root.querySelector('[data-approve-error]');
    var approvedBox = root.querySelector('[data-approved]');

    // 2026-09-23: this used to be a Shopify contact-form submit, kept alive purely to email
    // Wes. Every field in it was hidden and script-filled with no real typing -- close to the
    // textbook shape hCaptcha's heuristics flag as bot-like -- so real customers were hitting
    // an interactive challenge on a single click and approvals silently went nowhere. Wes
    // confirmed he doesn't need the email (Airtable + the pipeline picking it up is enough),
    // so this is now a plain button calling the Worker's /approve endpoint directly -- a
    // custom API, not Shopify's contact form, so hCaptcha never enters the picture. Awaited
    // (not fire-and-forget) since it's now the ONLY thing that has to succeed.
    if (isPaid && approveSend) {
      var approveSendDefaultText = approveSend.textContent;

      approveSend.addEventListener('click', function () {
        if (!CFG.approveEndpoint || !ref) return;

        if (approveError) approveError.hidden = true;
        approveSend.disabled = true;
        approveSend.textContent = 'Sending…';

        var approvedArt = safeText(param('a', 'art'), 120);
        if (!/^[A-Za-z0-9._-]+$/.test(approvedArt)) approvedArt = '';

        fetch(CFG.approveEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ref: ref, art: approvedArt })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('approve endpoint returned ' + res.status);

            if (approvedBox) approvedBox.hidden = false;
            if (approveBox) approveBox.hidden = true;
            verdict.value = null;
            renderVerdict();
            if (approvedBox) approvedBox.hidden = false;
          })
          .catch(function () {
            approveSend.disabled = false;
            approveSend.textContent = approveSendDefaultText;
            if (approveError) approveError.hidden = false;
          });
      });
    }

    if (loveBtn) {
      loveBtn.addEventListener('click', function () {
        verdict.value = 'love';
        if (changeSentBox) changeSentBox.hidden = true;
        renderVerdict();
      });
    }
    if (changeToggle) {
      changeToggle.addEventListener('click', function () {
        verdict.value = verdict.value === 'change' ? null : 'change';
        if (changeSentBox) changeSentBox.hidden = true;
        renderVerdict();
      });
    }

    // ── Revision request ─────────────────────────────────────────
    var changeForm = root.querySelector('[data-change-form]');
    var changeText = root.querySelector('[data-change-text]');
    var changeEmail = root.querySelector('[data-change-email]');
    var changeSend = root.querySelector('[data-change-send]');
    var changeError = root.querySelector('[data-change-error]');

    function changeFail(msg) {
      if (!changeError) return;
      changeError.textContent = msg;
      changeError.hidden = false;
    }

    // The endpoint URL is visible in this page's source, so client-side checks
    // can only stop bots, double-clicks and accidents — not someone determined
    // who reads the source. The page being noindex and reachable only from an
    // unguessable emailed link is what keeps it off crawlers' radar, and the
    // Airtable automation ignores any request whose ref doesn't match a real
    // record, so a bogus POST writes nothing.
    var changeHp = root.querySelector('[data-change-hp]');
    var loadedAt = Date.now();
    var MIN_DWELL_MS = 3000;
    var MIN_LEN = 10;
    var MAX_LEN = 2000;
    var LOCK_MS = 24 * 60 * 60 * 1000;
    // Per CAR, not per order (2026-09-23): cars of a multi-vehicle order share the ref, so a
    // ref-only key let a request on one car block the other car's request for 24 hours.
    var lockKey = 'wkd:revision:' + (ref || 'unknown') + ':' + (param('a', 'art') || '');

    function alreadySent() {
      try {
        var raw = window.localStorage.getItem(lockKey);
        return !!raw && Date.now() - Number(raw) < LOCK_MS;
      } catch (e) {
        return false;
      }
    }
    function markSent() {
      try {
        window.localStorage.setItem(lockKey, String(Date.now()));
      } catch (e) {
        /* private mode — the other guards still apply */
      }
    }

    // Carry the order context into the emailed message.
    var ctx = {
      ref: root.querySelector('[data-ctx-ref]'),
      name: root.querySelector('[data-ctx-name]'),
      car: root.querySelector('[data-ctx-car]'),
      art: root.querySelector('[data-ctx-art]')
    };
    if (ctx.ref) ctx.ref.value = ref || '';
    if (ctx.name) ctx.name.value = customerName || '';
    if (ctx.car) ctx.car.value = carName || '';
    if (ctx.art) ctx.art.value = artUrl || '';

    if (changeForm) {
      changeForm.addEventListener('submit', function (e) {
        // First, unconditionally: this form must never navigate (see the markup comment).
        e.preventDefault();
        if (changeError) changeError.hidden = true;
        var message = changeText ? changeText.value.trim() : '';

        // Honeypot: a real customer cannot see this field. Report success so a
        // bot gets no signal about why it failed, but send nothing.
        if (changeHp && changeHp.value) {
          if (changeSentBox) changeSentBox.hidden = false;
          verdict.value = null;
          renderVerdict();
          return;
        }

        var email = changeEmail ? changeEmail.value.trim() : '';

        function reject(msg, focusEl) {
          e.preventDefault();
          changeFail(msg);
          if (focusEl) focusEl.focus();
        }

        if (message.length < MIN_LEN) {
          reject(
            message ? 'Could you give me a little more detail?' : 'Tell me what you would like changed first.',
            changeText
          );
          return;
        }
        if (message.length > MAX_LEN) {
          reject('That is a bit long for this box. Please email me instead and I will read every word.');
          return;
        }
        // Optional since 2026-09-23: the request goes straight to the pipeline, which already
        // has the customer's email from their record. Only a TYPED address has to look valid.
        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          reject('That email address does not look right.', changeEmail);
          return;
        }
        if (Date.now() - loadedAt < MIN_DWELL_MS) {
          reject('Give me one moment, then press send again.');
          return;
        }
        if (alreadySent()) {
          reject(
            "I've already got your revision request for this piece. Email " +
              CFG.contactEmail +
              ' if you need to add anything.'
          );
          return;
        }

        // 2026-09-23: sent straight to the pipeline's Worker, the same way Approve works (theme
        // commit 1352675). This used to be a native Shopify contact-form submit with a
        // fire-and-forget `keepalive` fetch riding alongside it, which failed twice over on
        // #1460: Chrome refuses a keepalive request that needs a CORS preflight (a JSON POST to
        // another domain does), so the Worker never received anything; and the contact form's
        // round trip through Shopify's spam challenge came back to "link is missing its
        // artwork". Now nothing navigates, the request is awaited, and the customer sees a real
        // error if it fails. Wes is notified by an Airtable automation on "Revision Requested".
        e.preventDefault();
        if (!CFG.revisionEndpoint || !ref) {
          changeFail("Sorry, this couldn't be sent from here. Please email " + CFG.contactEmail + ' instead.');
          return;
        }

        // The artwork filename says WHICH car the change is for -- sibling cars of one
        // multi-vehicle order share the ref (same as the approve call above).
        var revisionArt = safeText(param('a', 'art'), 120);
        if (!/^[A-Za-z0-9._-]+$/.test(revisionArt)) revisionArt = '';
        var sentMessage = email ? message + '\n\n(Reply to: ' + email + ')' : message;
        var changeSendDefaultText = changeSend.textContent;
        changeSend.disabled = true;
        changeSend.textContent = 'Sending…';

        fetch(CFG.revisionEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ref: ref, message: sentMessage, art: revisionArt })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('revision endpoint returned ' + res.status);
            markSent();
            if (changeText) changeText.value = '';
            verdict.value = null;
            renderVerdict();
            if (changeSentBox) changeSentBox.hidden = false;
          })
          .catch(function () {
            changeSend.disabled = false;
            changeSend.textContent = changeSendDefaultText;
            changeFail("Sorry, that didn't go through. Please try again, or email " + CFG.contactEmail + '.');
          });
      });
    }

    // ── Add to cart ──────────────────────────────────────────────
    // `Print File URL` is what makes Gelato accept the order for production.
    // `Thumbnail Image URL` is the small original used by the confirmation
    // email; `Preview Ref` links the order back to Airtable.
    function properties() {
      var p = {
        'Print File URL': printUrl,
        'Thumbnail Image URL': artUrl
      };
      if (ref) p['Preview Ref'] = ref;
      return p;
    }

    // Order mode: the buttons are real submit buttons and the browser posts
    // the multipart form itself — one native POST, every vehicle as its own
    // items[N] line item (verified live against the real cart: bracket-array
    // items[0], items[1]... each keep their own distinct properties,
    // including file fields). Intercepting here would drop the photos, so
    // the only job is to refuse a submit that would fail, checking every
    // vehicle rather than just one.
    if (orderForm) {
      orderForm.addEventListener('submit', function (e) {
        for (var i = 0; i < vehicleControllers.length; i++) {
          var vc = vehicleControllers[i];
          var result = vc.render();
          if (!result.variant) {
            e.preventDefault();
            updateOrderTotals();
            if (vc.el) vc.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          if (!vc.hasPhoto() && !vc.el.querySelector('[data-photo-later]:checked')) {
            e.preventDefault();
            var label = vehicleControllers.length > 1
              ? (CFG.photoRequiredVehicle || 'Please choose a photo for') + ' ' +
                (CFG.vehicleLabel || 'Vehicle') + ' ' + (i + 1) + '.'
              : CFG.photoRequired;
            vc.uploadFail(label);
            if (vc.uploadBox) vc.uploadBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
        }
      });
    }

    buyBtns.forEach(function (btn) {
      if (isOrder) return;
      btn.addEventListener('click', function () {
        if (!primaryController) return;
        var result = primaryController.render();
        var current = result.variant;
        if (!current) return;

        var shop = root.getAttribute('data-shop-domain');
        var props = properties();

        var previewCompanion =
          primaryController.state.companion && CFG.companion.enabled && CFG.companion.variantId;
        var previewExtraItems = [];
        if (dupeOn && current) {
          var d = dupeItem(current, '');
          if (d) previewExtraItems.push(d);
        }

        // Nothing added: the proven GET redirect, unchanged from the
        // standalone page that is already accepted by Gelato in production.
        if (!previewCompanion && !previewExtraItems.length) {
          var q = new URLSearchParams();
          q.set('id', String(current.id));
          q.set('quantity', '1');
          Object.keys(props).forEach(function (k) {
            q.set('properties[' + k + ']', props[k]);
          });
          q.set('return_to', offerOn() ? offerApi().checkout() : '/checkout');
          window.location.href = 'https://' + shop + '/cart/add?' + q.toString();
          return;
        }

        // Something was added alongside the main piece, so more than one line
        // item — that needs the Ajax cart rather than the GET redirect.
        // Every extra carries the SAME Gelato properties as the main piece,
        // because it is the same artwork printed again, plus the marker that
        // keeps ingest from reading it as a second commission.
        var previewItems = [{ id: current.id, quantity: 1, properties: props }];
        if (previewCompanion) {
          previewItems.push({
            id: Number(CFG.companion.variantId),
            quantity: 1,
            properties: companionProps(props)
          });
        }
        previewExtraItems.forEach(function (e) {
          previewItems.push({ id: e.variant.id, quantity: 1, properties: companionProps(props) });
        });

        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: previewItems })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('bad status');
            window.location.href = offerOn() ? offerApi().checkout() : '/checkout';
          })
          .catch(function () {
            btn.disabled = false;
            window.location.href = '/cart';
          });
      });
    });

    // ── Phone order bar (2026-10-04) ─────────────────────────────
    // Visible only when the artwork stage has scrolled up out of view AND the
    // real Order button is off screen (above or below). CSS keeps it to phones.
    (function stickyOrderBar() {
      var bar = root.querySelector('[data-sticky]');
      var mainBtn = buyBtns[0];
      if (!bar || !mainBtn || isOrder || isPaid) return;
      var stageEl = root.querySelector('[data-stage]');
      var barBtn = bar.querySelector('[data-sticky-buy]');

      barBtn.addEventListener('click', function () {
        // No valid size/finish combination picked: send them to the options
        // rather than clicking a disabled button that does nothing.
        if (mainBtn.disabled) {
          mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        mainBtn.click();
      });

      var ticking = false;
      function update() {
        ticking = false;
        var vh = window.innerHeight;
        // With the artwork pinned (redesigned phone layout) the stage never leaves the screen, so
        // "docked" counts as gone.
        var stageGone =
          !stageEl ||
          stageEl.getBoundingClientRect().bottom < 0 ||
          !!(v2DockState && v2DockState.isDocked());
        var b = mainBtn.getBoundingClientRect();
        // With the artwork pinned, anything under it is hidden behind it, so the button only
        // counts as on screen if it is below the pinned stage's bottom edge.
        var topLimit = 0;
        if (v2DockState && v2DockState.isDocked()) {
          var pinned = root.querySelector('.apv-hero');
          if (pinned) topLimit = Math.max(0, pinned.getBoundingClientRect().bottom);
        }
        var mainOnScreen = b.bottom > topLimit && b.top < vh;
        var show = stageGone && !mainOnScreen && !root.classList.contains('is-superseded');
        bar.hidden = !show;
        document.documentElement.classList.toggle('apv-sticky-on', show);
      }
      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    })();

    // Returning from a submit. Shopify's own rendering is the source of truth:
    // an error element means it did not go, whatever the URL says.
    var serverError = root.querySelector('[data-change-server-error]');

    if (serverError) {
      verdict.value = 'change';
      renderVerdict();
      serverError.scrollIntoView({ block: 'center' });
      // It never sent, so let them try again.
      try {
        window.localStorage.removeItem(lockKey);
      } catch (err) {
        /* nothing to clean up */
      }
    } else if (justPosted) {
      var wasApproval = false;
      try {
        wasApproval = window.sessionStorage.getItem(APPROVED_KEY) !== null;
        window.sessionStorage.removeItem(APPROVED_KEY);
        window.sessionStorage.removeItem(RESTORE_KEY);
      } catch (err) {
        /* nothing to clean up */
      }

      if (wasApproval && approvedBox) {
        approvedBox.hidden = false;
        // The decision is made; don't leave the approve button live.
        if (approveBox) approveBox.hidden = true;
        verdict.value = null;
        renderVerdict();
        if (approvedBox) approvedBox.hidden = false;
      } else if (changeSentBox) {
        changeSentBox.hidden = false;
      }
    }

    renderVerdict();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ba-slider]').forEach(function (slider) {
    var frame = slider.querySelector('.ba-slider-frame');
    var range = slider.querySelector('[data-ba-range]');
    if (!frame || !range) return;

    function update() {
      frame.style.setProperty('--reveal', range.value + '%');
    }
    range.addEventListener('input', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-slide]');
    if (slides.length >= 2 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-on');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-on');
      }, 6000);
    }

    var marquee = hero.querySelector('.ch-marquee');
    var track = hero.querySelector('[data-track]');
    if (!marquee || !track) return;

    function pauseMarquee() {
      track.style.animationPlayState = 'paused';
    }

    marquee.addEventListener('touchstart', pauseMarquee, { passive: true });
    marquee.addEventListener('pointerdown', pauseMarquee, { passive: true });
  });

  document.querySelectorAll('[data-gallery]').forEach(function (root) {
    var track = root.querySelector('[data-gal-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gal-thumb]'));
    var navBtns = Array.prototype.slice.call(root.querySelectorAll('[data-gal-nav]'));
    if (!track || thumbs.length < 2) return;

    // Autoplay: advances to the next slide on an interval read from the
    // section's "Auto-scroll speed" setting. A manual swipe, arrow click, or
    // thumbnail click pauses it rather than fighting the visitor's own
    // navigation — it resumes on the same interval once they stop.
    var autoplayEnabled = root.getAttribute('data-gal-autoplay') === 'true';
    var autoplayInterval = parseInt(root.getAttribute('data-gal-interval'), 10) || 5000;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayTimer = null;
    var resumeTimer = null;

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled || reducedMotion || thumbs.length < 2) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        var next = (i + 1) % thumbs.length;
        track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
      }, autoplayInterval);
    }

    function pauseAutoplay() {
      stopAutoplay();
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(startAutoplay, autoplayInterval);
    }

    track.addEventListener('pointerdown', pauseAutoplay, { passive: true });
    track.addEventListener('touchstart', pauseAutoplay, { passive: true });
    root.addEventListener('keydown', pauseAutoplay);

    function syncActive() {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      i = Math.max(0, Math.min(thumbs.length - 1, i));
      thumbs.forEach(function (thumb, idx) {
        var on = idx === i;
        thumb.classList.toggle('is-on', on);
        thumb.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function updateNav() {
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      navBtns.forEach(function (btn) {
        var dir = parseInt(btn.getAttribute('data-gal-nav'), 10);
        btn.disabled = dir < 0 ? atStart : atEnd;
      });
    }

    navBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-gal-nav'), 10);
        track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
        pauseAutoplay();
      });
    });

    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () {
        track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
        pauseAutoplay();
      });
    });

    // Native scroll fires continuously while swiping, so the active-thumbnail
    // sync is debounced; the disabled state on the arrows updates live so it
    // never lags behind a fast swipe.
    var syncTimer;
    track.addEventListener(
      'scroll',
      function () {
        updateNav();
        clearTimeout(syncTimer);
        syncTimer = setTimeout(syncActive, 80);
      },
      { passive: true }
    );

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
      if (e.key === 'ArrowRight') track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
    });

    window.addEventListener('resize', updateNav);

    syncActive();
    updateNav();
    startAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-faq]').forEach(function (root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('details'));
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["free-preview-landing-2-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sticky = document.querySelector('[data-fp2-sticky]');
    var form = document.querySelector('.pfl');
    var finalSection = document.querySelector('[data-fp2-final]');
    if (!sticky) return;
    var blocked = false;
    var update = function () {
      sticky.hidden = window.innerWidth > 760 || window.scrollY < 520 || blocked;
    };
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        blocked = entries.some(function (entry) { return entry.isIntersecting; });
        update();
      }, { rootMargin: '-10% 0px -10% 0px' });
      if (form) observer.observe(form);
      if (finalSection) observer.observe(finalSection);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gg]').forEach(function (root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-tags]'));
    var count = root.querySelector('[data-count]');

    function apply(key) {
      var shown = 0;
      cards.forEach(function (card) {
        var tags = (card.getAttribute('data-tags') || '').split(/[,\s]+/);
        var match = key === 'all' || tags.indexOf(key) !== -1;
        card.hidden = !match;
        if (match) shown++;
      });
      buttons.forEach(function (b) {
        var on = b.getAttribute('data-filter') === key;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (count) {
        count.textContent = shown === 0
          ? 'Nothing in this style yet. Check back shortly.'
          : shown + (shown === 1 ? ' commission shown' : ' commissions shown');
      }
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        apply(b.getAttribute('data-filter'));
      });
    });

    apply(buttons.length ? buttons[0].getAttribute('data-filter') : 'all');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-wall"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gallery]').forEach(function (root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-tags]'));
    var empty = root.querySelector('[data-empty]');

    function apply(key) {
      var shown = 0;
      items.forEach(function (item) {
        var tags = (item.getAttribute('data-tags') || '').split(/[,\s]+/);
        var match = key === 'all' || tags.indexOf(key) !== -1;
        item.hidden = !match;
        if (match) shown++;
      });
      if (empty) empty.hidden = shown !== 0;

      buttons.forEach(function (b) {
        var on = b.getAttribute('data-filter') === key;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        apply(b.getAttribute('data-filter'));
      });
    });

    // The style selector above broadcasts the chosen style.
    document.addEventListener('wkd:style', function (e) {
      var key = e.detail && e.detail.key;
      if (!key) return;
      // Only react if this gallery actually has that filter.
      var known = buttons.some(function (b) {
        return b.getAttribute('data-filter') === key;
      });
      if (!known) return;
      apply(key);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-header]').forEach(function (nav) {
    var btn = nav.querySelector('[data-burger]');
    if (!btn) return;

    function close() {
      nav.removeAttribute('data-open');
      btn.setAttribute('aria-expanded', 'false');
    }

    // Declared up here (not down by the rest of the return-bar logic below)
    // so publishHeight can read its visibility -- it needs to exist before
    // publishHeight's first call. Queried from `document`, not `nav`: the
    // bar is a sibling of <nav>, not a descendant (see the markup comment).
    var returnBanner = document.querySelector('[data-return-banner]');

    btn.addEventListener('click', function () {
      if (nav.hasAttribute('data-open')) {
        close();
      } else {
        nav.setAttribute('data-open', '');
        btn.setAttribute('aria-expanded', 'true');
      }
    });

    nav.querySelectorAll('[data-drawer] a').forEach(function (a) {
      a.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    // Return bar's own height (0 when hidden) -- .hd's sticky `top` reads
    // this so it sticks directly under the bar instead of the two
    // overlapping. Separate from --hd-h below since scroll-padding-top wants
    // BOTH bars' height, but .hd's own sticky offset wants only this one.
    function returnBarHeight() {
      return (returnBanner && !returnBanner.hidden) ? returnBanner.offsetHeight : 0;
    }
    function publishReturnHeight() {
      document.documentElement.style.setProperty('--return-h', returnBarHeight() + 'px');
    }

    // Publish the real header height (plus the return bar, if showing) so
    // sticky offsets elsewhere track it.
    function publishHeight() {
      var bar = nav.querySelector('.hd-bar');
      if (bar) {
        document.documentElement.style.setProperty('--hd-h', (bar.offsetHeight + returnBarHeight()) + 'px');
      }
      publishReturnHeight();
    }
    publishHeight();
    window.addEventListener('resize', publishHeight);

    // "View Your Artwork" return bar — reads what artwork-preview.liquid
    // saved the moment this browser last opened an emailed preview link.
    // Per-browser only (localStorage), not a real identity: this recognizes
    // the device, not the person, and never touches the server.
    if (returnBanner) {
      var RETURN_KEY = 'wkd:returnLink';
      var DISMISSED_KEY = 'wkd:returnLink:dismissed';
      var RETURN_MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000; // 90 days

      try {
        var raw = window.localStorage.getItem(RETURN_KEY);
        if (raw) {
          var saved = JSON.parse(raw);
          var age = Date.now() - (saved.ts || 0);
          var currentUrl = window.location.pathname + window.location.search;

          if (age > RETURN_MAX_AGE_MS) {
            window.localStorage.removeItem(RETURN_KEY);
          } else if (
            saved.href &&
            saved.href !== currentUrl &&
            window.localStorage.getItem(DISMISSED_KEY) !== String(saved.ts)
          ) {
            var linkEl = returnBanner.querySelector('[data-return-link]');
            var textEl = returnBanner.querySelector('[data-return-text]');
            linkEl.setAttribute('href', saved.href);
            textEl.textContent = 'View Your Artwork' + (saved.name ? ', ' + saved.name : '') + ' →';
            returnBanner.hidden = false;
            publishHeight();
          }
        }
      } catch (err) {
        /* private mode / storage disabled — the pill just never appears */
      }

      var closeBtn = returnBanner.querySelector('[data-return-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          returnBanner.hidden = true;
          publishHeight();
          try {
            var rawSaved = window.localStorage.getItem(RETURN_KEY);
            if (rawSaved) {
              window.localStorage.setItem(DISMISSED_KEY, String(JSON.parse(rawSaved).ts));
            }
          } catch (err) {
            /* private mode / storage disabled */
          }
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-landing-2"] && !Shopify.designMode) return;
  try {
    
  function initHolidayPage(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const bar = root.querySelector('[data-holiday-sticky]');
    const hero = root.querySelector('.h2-hero');
    const final = root.querySelector('[data-holiday-final]');
    if (bar && hero && final && 'IntersectionObserver' in window) {
      let heroVisible = true;
      let finalVisible = false;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.target === hero) heroVisible = entry.isIntersecting; if (entry.target === final) finalVisible = entry.isIntersecting; });
        bar.hidden = heroVisible || finalVisible;
      });
      observer.observe(hero);
      observer.observe(final);
      root.addEventListener('shopify:section:unload', () => observer.disconnect(), { once:true });
    }
  }
  document.querySelectorAll('[data-holiday-page]').forEach(initHolidayPage);
  document.addEventListener('shopify:section:load', event => initHolidayPage(event.target.querySelector('[data-holiday-page]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["message-wes"] && !Shopify.designMode) return;
  try {
    
  /* Open Shopify's chat when it is on the page (the element is <shopify-chat>; setting .open opens the panel).
     Otherwise let the mailto: link do its job. */
  document.querySelectorAll('[data-message-wes-btn]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var chat = document.querySelector('shopify-chat');
      if (!chat) return;
      e.preventDefault();
      // 2026-10-17: the bubble is hidden sitewide (snippets/chat-launcher.liquid);
      // its opener handles both Inbox loading stages. Opened after this click
      // finishes so Inbox's click-outside doesn't close it; email if chat fails.
      if (typeof window.wkdOpenChat === 'function') {
        setTimeout(function () {
          window.wkdOpenChat(btn.href);
        }, 60);
        return;
      }
      try {
        chat.open = true;
      } catch (err) {
        window.location.href = btn.href;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policies"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-policies]').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-group]'));
    var entries = Array.prototype.slice.call(root.querySelectorAll('[data-entry-group]'));

    function show(id) {
      groups.forEach(function (g) {
        g.hidden = g.getAttribute('data-group') !== id;
      });
      entries.forEach(function (e) {
        e.hidden = e.getAttribute('data-entry-group') !== id;
      });
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-tab') === id;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        show(t.getAttribute('data-tab'));
      });
    });

    if (tabs.length) show(tabs[0].getAttribute('data-tab'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-portfolio]').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
    var soons = Array.prototype.slice.call(root.querySelectorAll('[data-soon]'));
    var moreWrap = root.querySelector('[data-more]');
    var moreBtn = root.querySelector('[data-load-more]');
    var remaining = root.querySelector('[data-remaining]');
    var batch = parseInt(root.getAttribute('data-batch'), 10) || 4;

    var grid = root.querySelector('[data-grid]');
    var isSlider = !!(grid && grid.classList.contains('pf-grid--slider'));

    var current = tabs.length ? tabs[0].getAttribute('data-tab') : null;
    var shown = isSlider ? Infinity : batch;

    function matching(key) {
      return cards.filter(function (c) {
        return !key || c.getAttribute('data-style') === key;
      });
    }

    function render() {
      var pool = matching(current);

      cards.forEach(function (c) {
        c.hidden = true;
      });
      pool.slice(0, shown).forEach(function (c) {
        c.hidden = false;
      });

      soons.forEach(function (s) {
        s.hidden = !(s.getAttribute('data-soon') === current && pool.length === 0);
      });

      var left = pool.length - shown;
      if (moreWrap) moreWrap.hidden = left <= 0;
      if (remaining && left > 0) {
        remaining.textContent = left + (left === 1 ? ' more commission' : ' more commissions');
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        current = tab.getAttribute('data-tab');
        shown = isSlider ? Infinity : batch; // reset the reveal count when the style changes
        if (grid) grid.scrollTo({ left: 0 });
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        render();
        updateNav();
      });
    });

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        shown += batch;
        render();
      });
    }

    var updateNav = function () {};

    if (isSlider && grid) {
      var navBtns = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));

      updateNav = function () {
        var atStart = grid.scrollLeft <= 1;
        var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 1;
        navBtns.forEach(function (btn) {
          var dir = parseInt(btn.getAttribute('data-slide'), 10);
          btn.disabled = dir < 0 ? atStart : atEnd;
        });
      };

      navBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-slide'), 10);
          grid.scrollBy({ left: dir * grid.clientWidth * 0.9, behavior: 'smooth' });
        });
      });

      grid.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
    }

    render();
    updateNav();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preview-flow"] && !Shopify.designMode) return;
  try {
    
  // Cloudflare Turnstile calls these BY NAME (data-callback / data-error-callback
  // / data-timeout-callback on the widget, see snippets/preview-*-fields.liquid).
  // They only broadcast to the form(s) registered below, which decide what to show.
  window.wkdTsListeners = window.wkdTsListeners || [];
  window.wkdTsOk = function () {
    window.wkdTsListeners.forEach(function (fn) {
      fn(true);
    });
  };
  window.wkdTsError = function (code) {
    window.wkdTsListeners.forEach(function (fn) {
      fn(false, code);
    });
  };

  document.querySelectorAll('[data-flow]').forEach(function (root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-style]'));
    var mark1 = root.querySelector('[data-mark="1"]');
    var mark2 = root.querySelector('[data-mark="2"]');
    var panel = root.querySelector('[data-panel]');
    var form = root.querySelector('.pfl-form');
    var chosenOut = root.querySelector('[data-chosen]');
    var styleInput = root.querySelector('[data-style-input]');
    var errorBox = root.querySelector('[data-error]');
    var done = root.querySelector('[data-done]');
    var chosen = root.getAttribute('data-default-style') || null;

    if (chosenOut && chosen) chosenOut.textContent = chosen;
    if (styleInput && chosen) styleInput.value = chosen;

    function selectStyle(card, focus) {
      chosen = card.getAttribute('data-style-label');
      cards.forEach(function (c) {
        var on = c === card;
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.setAttribute('tabindex', on ? '0' : '-1');
      });
      if (chosenOut) chosenOut.textContent = chosen;
      if (styleInput) styleInput.value = chosen;
      if (mark1) {
        mark1.classList.add('is-done');
        mark1.textContent = '✓';
      }
      if (panel) panel.classList.add('is-ready');
      if (focus) card.focus();
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () {
        selectStyle(card, false);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          selectStyle(card, false);
          return;
        }
        var dir = 0;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
        if (!dir) return;
        e.preventDefault();
        selectStyle(cards[(i + dir + cards.length) % cards.length], true);
      });
    });

    if (!form) return;

    // Ad attribution: snippets/attribution-capture.liquid remembers the ad's
    // URL parameters across pages; this files them with the submission as
    // hidden attr_* fields for the Worker (worker/src/attribution.js). Runs at
    // load AND again at submit (capture phase, so before the validation
    // handler below) so the values are current even after a long visit.
    // Entirely best-effort: if the snippet is missing or storage is blocked
    // the form submits exactly as before.
    function stampAttribution() {
      if (!window.wkdAttribution) return;
      var values;
      try {
        values = window.wkdAttribution.fields();
      } catch (err) {
        return;
      }
      Object.keys(values).forEach(function (name) {
        var input = form.querySelector('input[type="hidden"][name="' + name + '"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }
        input.value = values[name];
      });
    }
    stampAttribution();
    form.addEventListener('submit', stampAttribution, true);

    var fileInput = form.querySelector('input[type="file"]');
    var upload = form.querySelector('[data-upload]');
    var upText = form.querySelector('[data-up-text]');
    var upHint = form.querySelector('[data-up-hint]');
    var upThumb = form.querySelector('[data-up-thumb]');
    var defText = upText ? upText.textContent : '';
    var defHint = upHint ? upHint.textContent : '';

    if (fileInput && upload) {
      fileInput.addEventListener('change', function () {
        if (fileInput.files.length) {
          // Not the file's own name (2026-10-01): Facebook's in-app browser hands over
          // camera-roll photos as "inbound1234567890..." -- meaningless, and a single
          // unbroken string that ran off the side of the screen. The thumbnail and the
          // check badge already show WHICH photo was picked.
          upText.textContent = 'Photo added';
          upHint.textContent = 'Tap to choose a different photo';
          upload.classList.add('is-filled');
          if (upThumb) {
            var reader = new FileReader();
            reader.onload = function (e) {
              upThumb.src = e.target.result;
              upThumb.hidden = false;
            };
            reader.readAsDataURL(fileInput.files[0]);
          }
        } else {
          upText.textContent = defText;
          upHint.textContent = defHint;
          if (upThumb) {
            upThumb.hidden = true;
            upThumb.src = '';
          }
          upload.classList.remove('is-filled');
        }
      });
      ['dragenter', 'dragover'].forEach(function (evt) {
        upload.addEventListener(evt, function (e) {
          e.preventDefault();
          upload.classList.add('is-over');
        });
      });
      ['dragleave', 'drop'].forEach(function (evt) {
        upload.addEventListener(evt, function () {
          upload.classList.remove('is-over');
        });
      });
    }

    // quiet = show without pulling the page to the message (used for the
    // proactive blocked-check notice, which appears while they're mid-form).
    function fail(msg, quiet) {
      if (!errorBox) return;
      errorBox.textContent = '! ' + msg;
      errorBox.hidden = false;
      if (!quiet) errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    // Blocked security check. Cloudflare's script (api.js) is what produces
    // the token the Worker requires, so an ad blocker or strict privacy
    // shield that stops it loading means NO token and a guaranteed
    // "verification failed" bounce — which also empties the form, photo
    // included, since this is a native submit. Two defences:
    //   1. after 6s with no window.turnstile, say so up front;
    //   2. on submit, don't send at all while it is still missing.
    // Checked live each time rather than latched, so a slow connection that
    // finishes loading later is never wrongly stopped. The Worker still
    // rejects a missing token — this only saves the customer the round trip.
    var tsWidget = root.querySelector('.cf-turnstile');
    var tsMsg = tsWidget ? tsWidget.getAttribute('data-ts-blocked-msg') : '';
    var tsNoticeShown = false;
    function tsMissing() {
      return !!tsWidget && typeof window.turnstile === 'undefined';
    }
    if (tsWidget && tsMsg) {
      window.setTimeout(function () {
        if (tsMissing()) {
          tsNoticeShown = true;
          fail(tsMsg, true);
        }
      }, 6000);
      var tsScript = document.querySelector('script[src*="challenges.cloudflare.com/turnstile"]');
      if (tsScript) {
        tsScript.addEventListener('load', function () {
          if (tsNoticeShown && errorBox) {
            errorBox.hidden = true;
            tsNoticeShown = false;
          }
        });
      }
    }

    // A check that LOADS but then fails or never finishes. The blocked-script
    // defence above can't see it (window.turnstile exists), and the widget is
    // invisible, so the customer sees nothing until a whole photo has uploaded
    // and the Worker bounces it with "verification failed" -- which is what an
    // older iPhone hit on 2026-09-24. Three defences:
    //   1. Cloudflare's error/timeout callback: say so up front, with an email
    //      fallback. A later success clears it (Turnstile retries by itself);
    //   2. submit with no token yet: wait for it (normally seconds away) and
    //      send automatically, instead of sending without one;
    //   3. still no token after TS_WAIT_MS: show the same fallback.
    // Nothing on the page is reset by any of this, so the photo and email the
    // customer already entered are kept. The Worker still rejects a missing
    // token; this only saves the customer the round trip. A blank
    // turnstile_stuck_message turns the whole thing off.
    var TS_WAIT_MS = 12000;
    var tsStuckMsg = tsWidget ? tsWidget.getAttribute('data-ts-stuck-msg') : '';
    var tsErrored = false;
    var tsStuckShown = false;
    var tsWaitTimer = null;
    var tsPollTimer = null;
    var submitBtn = form.querySelector('[data-submit]');
    var submitLbl = submitBtn ? submitBtn.querySelector('[data-submit-label]') : null;
    var submitDefault = submitLbl ? submitLbl.textContent : '';

    function tsToken() {
      var input = form.querySelector('input[name="cf-turnstile-response"]');
      return input ? input.value : '';
    }

    // The message plus a tappable mailto link (errorBox is a flex row, so both
    // go inside one span to stay on the same line of text).
    function showStuck(quiet) {
      if (!errorBox) return;
      var link = document.createElement('a');
      link.href = 'mailto:Wes@weskleedesigns.com?subject=' + encodeURIComponent('Free preview photo');
      link.textContent = 'Email your photo to Wes@weskleedesigns.com';
      link.style.cssText = 'color:inherit;text-decoration:underline;';
      var wrap = document.createElement('span');
      wrap.appendChild(document.createTextNode('! ' + tsStuckMsg + ' '));
      wrap.appendChild(link);
      errorBox.textContent = '';
      errorBox.appendChild(wrap);
      errorBox.hidden = false;
      tsStuckShown = true;
      if (!quiet) errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function stopWaiting() {
      window.clearTimeout(tsWaitTimer);
      window.clearInterval(tsPollTimer);
      tsWaitTimer = null;
      tsPollTimer = null;
      if (submitLbl) submitLbl.textContent = submitDefault;
      if (submitBtn) submitBtn.removeAttribute('aria-busy');
    }

    function beginSending() {
      if (mark2) {
        mark2.classList.add('is-done');
        mark2.textContent = '✓';
      }
      if (submitBtn) {
        if (submitLbl) submitLbl.textContent = 'Sending…';
        // Deferred: disabling the submitter synchronously inside a submit
        // handler makes the browser abort the submission entirely.
        window.setTimeout(function () {
          submitBtn.setAttribute('aria-busy', 'true');
          submitBtn.disabled = true;
        }, 0);
      }
    }

    // Re-submits once the token has arrived. requestSubmit() re-runs this
    // form's own submit handler (validation, attribution stamping); older
    // Safari lacks it, so there the already-validated form is sent directly.
    function sendNow() {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        beginSending();
        form.submit();
      }
    }

    function waitForToken() {
      if (tsWaitTimer) return;
      if (submitLbl) submitLbl.textContent = 'One moment…';
      // aria-busy also makes the button ignore taps (see .pfl-submit).
      if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');
      tsPollTimer = window.setInterval(function () {
        if (tsToken()) {
          stopWaiting();
          sendNow();
        }
      }, 400);
      tsWaitTimer = window.setTimeout(function () {
        stopWaiting();
        showStuck(false);
      }, TS_WAIT_MS);
    }

    if (tsWidget && tsStuckMsg) {
      window.wkdTsListeners.push(function (ok) {
        if (ok) {
          tsErrored = false;
          if (tsStuckShown && errorBox) {
            errorBox.hidden = true;
            tsStuckShown = false;
          }
        } else if (!tsWaitTimer) {
          tsErrored = true;
          showStuck(true);
        }
      });
    }

    // The Worker 303-redirects failures back here with ?preview_error=<code>
    // (see worker/src/index.js) instead of showing its own error page.
    var PREVIEW_ERROR_MESSAGES = {
      verification_failed: 'Verification failed, please try submitting again.',
      missing_email: 'Please enter your email.',
      missing_photo: 'Please add a photo of your car so Wes can create your preview.',
      bad_photo_type: "That file type isn't supported. Please upload a JPG, PNG, HEIC, or WEBP.",
      photo_too_large: 'That photo is over 20MB. Please choose a smaller one.',
      server_error: 'Something went wrong on my end, please try again in a moment.',
    };
    var previewError = new URLSearchParams(window.location.search).get('preview_error');
    if (previewError && PREVIEW_ERROR_MESSAGES[previewError]) {
      fail(PREVIEW_ERROR_MESSAGES[previewError]);
    }

    // The Worker rejects a file over this; matching it client-side avoids a
    // wasted round trip and loses none of what the customer just filled in.
    var MAX_MB = 20;

    form.addEventListener('submit', function (e) {
      if (errorBox) errorBox.hidden = true;

      if (cards.length && !chosen) {
        e.preventDefault();
        fail('Pick a style first, tap one of the two above.');
        return;
      }

      if (!fileInput || !fileInput.files || !fileInput.files.length) {
        e.preventDefault();
        fail('Please add a photo of your car so Wes can create your preview.');
        return;
      }

      if (fileInput.files[0].size > MAX_MB * 1024 * 1024) {
        e.preventDefault();
        fail('That photo is over ' + MAX_MB + 'MB. Please choose a smaller one.');
        return;
      }

      if (tsMsg && tsMissing()) {
        e.preventDefault();
        fail(tsMsg);
        return;
      }

      // Script loaded but no token yet (see the note above tsToken()).
      if (tsWidget && tsStuckMsg && !tsToken()) {
        e.preventDefault();
        if (tsErrored) showStuck(false);
        else waitForToken();
        return;
      }

      beginSending();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preview-received-pick"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-qpf-pick]');
    if (!root) return;
    var params = new URLSearchParams(window.location.search);
    var pi = params.get('pi');
    var ref = params.get('ref') || '';
    // Only a real submission (minted ref) with a known product key. ref=TEST previews it (2026-10-19): it
    // matches none of the Lead rules, so viewing it sends nothing to Meta.
    if (!pi || !(/^WKD-\d+$/.test(ref) || ref === 'TEST')) return;
    var wrap = root.querySelector('[data-pick-cards]');
    if (pi !== 'unsure') {
      var card = wrap && wrap.querySelector('[data-card="' + pi + '"]');
      if (!card) return;
      card.classList.add('is-yours');
      var badge = card.querySelector('[data-yours]');
      if (badge) badge.hidden = false;
      wrap.insertBefore(card, wrap.firstChild);
    }
    root.hidden = false;
  })();

  // Phone slider: dots follow the swipe, arrows step one card (wrapping at the ends). Re-wired when the theme
  // editor re-renders the section.
  (function () {
    function initPickSlider(scope) {
      var slider = scope.querySelector('[data-pick-slider]');
      if (!slider || slider.hasAttribute('data-ready')) return;
      slider.setAttribute('data-ready', '');
      var track = slider.querySelector('[data-pick-cards]');
      var dotsEl = slider.querySelector('[data-pick-dots]');
      var cards = track.children;
      for (var i = 0; i < cards.length; i++) dotsEl.appendChild(document.createElement('span'));
      var step = function () {
        return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
      };
      var current = function () {
        return Math.round(track.scrollLeft / Math.max(1, step()));
      };
      var onScroll = function () {
        var n = current();
        for (var j = 0; j < dotsEl.children.length; j++) dotsEl.children[j].classList.toggle('is-on', j === n);
      };
      track.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      slider.querySelectorAll('[data-pick-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var n = cards.length;
          var to = (current() + Number(btn.getAttribute('data-pick-nav')) + n) % n;
          var left = to * step();
          track.scrollTo({ left: left, behavior: 'smooth' });
          // Where smooth scrolling never runs, jump there instead so a tap always moves.
          setTimeout(function () {
            if (Math.abs(track.scrollLeft - left) > 2) track.scrollLeft = left;
          }, 700);
        });
      });
    }
    initPickSlider(document);
    document.addEventListener('shopify:section:load', function (e) {
      initPickSlider(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preview-received"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ref = new URLSearchParams(window.location.search).get('ref');
    var successEl = document.querySelector('[data-success-state]');
    var noRefEl = document.querySelector('[data-no-ref-state]');
    var tick = document.querySelector('[data-tick]');
    var timeline = document.querySelector('[data-timeline]');

    if (!ref) {
      // No proof this visitor actually submitted anything -- don't claim
      // "I've got your photo" or show a tick/timeline that imply it.
      if (successEl) successEl.hidden = true;
      if (tick) tick.hidden = true;
      if (timeline) timeline.hidden = true;
      if (noRefEl) noRefEl.hidden = false;
      return;
    }

    var line = document.querySelector('[data-ref-line]');
    var value = document.querySelector('[data-ref-value]');
    if (!line || !value) return;
    value.textContent = ref;
    line.hidden = false;
  })();

  /*
    Meta pixel `Lead` -- the event free-preview ad sets optimize on.
    Fires once per real submission. The event ID is the WKD-#### reference so
    a future server-side (Conversions API) Lead can reuse it and Meta will
    dedupe the pair into one. Kept in its own function so the early returns
    above can never skip it.
  */
  (function () {
    var ref = new URLSearchParams(window.location.search).get('ref');
    // Only a minted reference counts as a real submission (not a bookmark or
    // a hand-typed URL).
    if (!ref || !/^WKD-\d+$/.test(ref)) return;

    var sentKey = 'wkd:leadSent:' + ref;
    try {
      // A refresh or back-button return must not count a second lead.
      if (window.localStorage.getItem(sentKey)) return;
    } catch (e) {}

    function sendLead() {
      if (typeof window.fbq !== 'function') return false;
      window.fbq(
        'track',
        'Lead',
        { content_name: 'Free Preview', content_category: 'Custom Car Artwork' },
        { eventID: ref }
      );
      try {
        window.localStorage.setItem(sentKey, '1');
      } catch (e) {}
      return true;
    }

    // The pixel can finish loading a moment after this script runs; retry
    // briefly (5s max). If it never appears (blocker), give up quietly.
    if (sendLead()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (sendLead() || ++tries >= 20) clearInterval(timer);
    }, 250);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-legacy-product]').forEach(function (product) {
    var select = product.querySelector('select[name="id"]');
    var price = product.querySelector('[data-legacy-price]');
    if (!select || !price) return;
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      if (option && option.dataset.price) price.textContent = option.dataset.price;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["request-preview-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-qph]').forEach(function (root) {
    var track = root.querySelector('[data-qph-track]');
    var dotsEl = root.querySelector('[data-qph-dots]');
    if (track && dotsEl) {
      var slides = track.children;
      for (var i = 0; i < slides.length; i++) dotsEl.appendChild(document.createElement('span'));
      var dots = dotsEl.children;
      var current = function () {
        return Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      };
      var onScroll = function () {
        var n = current();
        for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-on', j === n);
      };
      track.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      root.querySelectorAll('[data-qph-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var n = slides.length;
          var to = (current() + Number(btn.getAttribute('data-qph-nav')) + n) % n;
          var left = to * track.clientWidth;
          track.scrollTo({ left: left, behavior: 'smooth' });
          // Same fallback as product-builder.js slideTo(): jump if smooth scrolling didn't happen.
          setTimeout(function () {
            if (Math.abs(track.scrollLeft - left) > 2) track.scrollLeft = left;
            onScroll();
          }, 700);
        });
      });
    }
    // Funnel diagnostics only (the Lead event is on the thank-you page).
    root.querySelectorAll('[data-qph-start]').forEach(function (a) {
      a.addEventListener('click', function () {
        try {
          if (typeof window.fbq === 'function') window.fbq('trackCustom', 'PreviewStart', {});
        } catch (e) {}
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["request-preview"] && !Shopify.designMode) return;
  try {
    
  // Turnstile loads with ?render=explicit&onload=wkdQpfTsReady (see the script
  // tag): each form below registers a renderer here, run as soon as it loads.
  window.wkdQpfTsRenderers = window.wkdQpfTsRenderers || [];
  window.wkdQpfTsReady = function () {
    window.wkdQpfTsRenderers.forEach(function (fn) {
      fn();
    });
  };

  document.querySelectorAll('[data-qpf]').forEach(function (root) {
    var form = root.querySelector('[data-qpf-form]');
    if (!form) return;
    var steps = Array.prototype.slice.call(form.querySelectorAll('[data-step]'));
    var formTop = root.querySelector('#qpf-form');
    var pageError = form.querySelector('[data-page-error]');
    var current = 1;
    var MAX_MB = 20; // the Worker's MAX_PHOTO_BYTES

    function track(name, props) {
      // Funnel diagnostics only (which step people drop off at). Never the ad
      // optimization event: Lead still fires on the thank-you page.
      try {
        if (typeof window.fbq === 'function') window.fbq('trackCustom', name, props || {});
      } catch (e) {}
    }

    function stepEl(n) {
      return steps[n - 1];
    }
    function stepError(n) {
      return stepEl(n).querySelector('[data-step-error]');
    }
    function clearErrors() {
      steps.forEach(function (s) {
        var e = s.querySelector('[data-step-error]');
        if (e) e.hidden = true;
      });
      if (pageError) pageError.hidden = true;
    }
    function fail(n, msg, quiet) {
      var box = stepError(n);
      if (!box) return;
      box.textContent = msg;
      box.hidden = false;
      if (!quiet) box.scrollIntoView({ block: 'center' });
    }

    function show(n, focus) {
      current = n;
      steps.forEach(function (s, i) {
        s.hidden = i !== n - 1;
      });
      if (n === steps.length) {
        fillSummary();
        if (tsExhausted && !tsLastChance) {
          tsLastChance = true;
          tsExhausted = false;
          tsAttempts = Math.max(0, TS_MAX_TRIES - 2);
          resetTs(0);
        }
      }
      if (focus !== false) {
        if (formTop) formTop.scrollIntoView({ block: 'start' });
        var t = stepEl(n).querySelector('[data-step-title]');
        if (t) t.focus({ preventScroll: true });
      }
    }

    function checked(name) {
      return form.querySelector('input[name="' + name + '"]:checked');
    }

    // ---- step 1: what they like + print or canvas ----
    form.querySelectorAll('[data-like]').forEach(function (r) {
      r.addEventListener('change', function () {
        form.querySelectorAll('input[name="' + r.name + '"]').forEach(function (o) {
          var lab = o.closest('.qpf-option');
          if (lab) lab.classList.toggle('is-picked', o.checked);
        });
        stepError(1).hidden = true;
      });
    });
    // "Just curious" drops down the gallery message and hides the rest of
    // step 1 (and its Continue button) until a real choice is made.
    var curious = form.querySelector('[data-curious]');
    var afterInterest = form.querySelector('[data-after-interest]');
    var afterNav = form.querySelector('[data-after-interest-nav]');
    var curiousOpt = form.querySelector('.qpf-option--curious');
    form.querySelectorAll('[data-product-radio]').forEach(function (r) {
      r.addEventListener('change', function () {
        form.querySelectorAll('.qpf-card').forEach(function (c) {
          var input = c.querySelector('input');
          c.classList.toggle('is-picked', !!(input && input.checked));
        });
        var isCurious = !!(checked('product_interest') && checked('product_interest').value === 'curious');
        if (curiousOpt) curiousOpt.classList.toggle('is-picked', isCurious);
        if (curious) curious.hidden = !isCurious;
        if (afterInterest) afterInterest.hidden = isCurious;
        if (afterNav) afterNav.hidden = isCurious;
        if (isCurious) track('PreviewJustCurious');
        stepError(1).hidden = true;
      });
    });
    // ---- step 1: photo ----
    var fileInput = form.querySelector('[data-photo]');
    var upload = form.querySelector('[data-upload]');
    var upText = form.querySelector('[data-up-text]');
    var upHint = form.querySelector('[data-up-hint]');
    var upThumb = form.querySelector('[data-up-thumb]');
    var upIcon = form.querySelector('[data-up-icon]');
    var upOk = form.querySelector('[data-up-ok]');
    var defText = upText ? upText.textContent : '';
    var defHint = upHint ? upHint.textContent : '';
    var thumbUrl = '';

    if (fileInput && upload) {
      fileInput.addEventListener('change', function () {
        thumbUrl = '';
        if (fileInput.files && fileInput.files.length) {
          // Not the file's own name: Facebook's in-app browser hands over
          // camera-roll photos as "inbound1234567890...", meaningless and long.
          var file = fileInput.files[0];
          var mb = (file.size / (1024 * 1024)).toFixed(1);
          var kind = ((file.name || '').split('.').pop() || '').toUpperCase();
          if (!kind || kind.length > 5) kind = 'Photo';
          upText.textContent = 'Photo added';
          upHint.textContent = kind + ' · ' + mb + ' MB · Tap to choose a different photo';
          upload.classList.add('is-filled');
          upload.classList.remove('has-thumb');
          if (upIcon) upIcon.hidden = true;
          if (upOk) upOk.hidden = false;
          stepError(1).hidden = true;
          var reader = new FileReader();
          reader.onload = function (e) {
            thumbUrl = e.target.result;
            upThumb.onload = function () {
              upload.classList.add('has-thumb');
            };
            upThumb.onerror = function () {
              // Many HEIC photos can't be drawn by the browser. The photo is
              // still attached and is sent as-is; say so plainly.
              upThumb.hidden = true;
              thumbUrl = '';
              upload.classList.remove('has-thumb');
              upHint.textContent = kind + ' · ' + mb + ' MB · Your photo is attached. This phone format can’t be previewed here, but it will reach me fine.';
            };
            upThumb.src = thumbUrl;
            upThumb.hidden = false;
          };
          reader.readAsDataURL(file);
        } else {
          upText.textContent = defText;
          upHint.textContent = defHint;
          upThumb.hidden = true;
          upThumb.src = '';
          if (upIcon) upIcon.hidden = false;
          if (upOk) upOk.hidden = true;
          upload.classList.remove('is-filled', 'has-thumb');
        }
      });
      ['dragenter', 'dragover'].forEach(function (evt) {
        upload.addEventListener(evt, function (e) {
          e.preventDefault();
          upload.classList.add('is-over');
        });
      });
      ['dragleave', 'drop'].forEach(function (evt) {
        upload.addEventListener(evt, function () {
          upload.classList.remove('is-over');
        });
      });
    }
    var carInput = form.querySelector('[data-car]');

    // ---- step 2: summary ----
    function fillSummary() {
      var p = checked('product_interest');
      var sumProduct = form.querySelector('[data-sum-product]');
      var sumCar = form.querySelector('[data-sum-car]');
      var sumThumb = form.querySelector('[data-sum-thumb]');
      if (sumProduct) sumProduct.textContent = p ? p.getAttribute('data-product-name') : '';
      if (sumCar) sumCar.textContent = carInput ? carInput.value.trim() : '';
      if (sumThumb) {
        sumThumb.hidden = !thumbUrl;
        if (thumbUrl) sumThumb.src = thumbUrl;
      }
      // No drawable thumbnail (e.g. HEIC) but a photo IS attached: a big check.
      var sumOk = form.querySelector('[data-sum-ok]');
      var hasFile = !!(fileInput && fileInput.files && fileInput.files.length);
      if (sumOk) sumOk.hidden = !(hasFile && !thumbUrl);
      if (sumCar && hasFile && !thumbUrl) sumCar.textContent = (sumCar.textContent ? sumCar.textContent + ' · ' : '') + 'Photo attached';
    }

    var emailInput = form.querySelector('[data-email]');
    var ack = form.querySelector('[data-ack]');
    if (ack) {
      ack.addEventListener('change', function () {
        ack.closest('.qpf-check').classList.remove('is-invalid');
      });
    }

    // Returns true when step n is complete; otherwise shows why.
    function validate(n, quiet) {
      if (n === 1) {
        var pi = checked('product_interest');
        if (!pi) return fail(1, 'Please choose Canvas or Fine Art Print.', quiet), false;
        if (pi.value === 'curious') {
          if (curious) curious.hidden = false;
          return fail(1, 'Previews are for people interested in a finished piece. See the gallery link above.', quiet), false;
        }
        if (!fileInput || !fileInput.files || !fileInput.files.length) return fail(1, 'Please add a photo of your car.', quiet), false;
        if (fileInput.files[0].size > MAX_MB * 1024 * 1024) return fail(1, 'That photo is over ' + MAX_MB + 'MB. Please choose a smaller one.', quiet), false;
        // 2026-10-19 (Wes): year/make/model, the look and the lighting are optional (the Worker's parseV2 agrees).
        if (carInput) carInput.removeAttribute('aria-invalid');
        return true;
      }
      if (n === 2) {
        var email = emailInput ? emailInput.value.trim() : '';
        if (!email || (emailInput && !emailInput.checkValidity())) {
          if (emailInput) emailInput.setAttribute('aria-invalid', 'true');
          return fail(2, 'Please enter a valid email so I can send your artwork.', quiet), false;
        }
        if (emailInput) emailInput.removeAttribute('aria-invalid');
        if (!ack || !ack.checked) {
          if (ack) ack.closest('.qpf-check').classList.add('is-invalid');
          return fail(2, 'Please tick the box to confirm you understand how the preview works.', quiet), false;
        }
        return true;
      }
      return true;
    }

    function next() {
      clearErrors();
      if (!validate(current)) return;
      track('PreviewStep', { step: current + 1 });
      show(current + 1);
    }

    form.querySelectorAll('[data-next]').forEach(function (b) {
      b.addEventListener('click', next);
    });
    form.querySelectorAll('[data-back]').forEach(function (b) {
      b.addEventListener('click', function () {
        clearErrors();
        show(current - 1);
      });
    });
    form.querySelectorAll('[data-goto]').forEach(function (b) {
      b.addEventListener('click', function () {
        clearErrors();
        show(parseInt(b.getAttribute('data-goto'), 10));
      });
    });
    // ---- ad attribution (same as preview-flow.liquid's stampAttribution) ----
    function stampAttribution() {
      if (!window.wkdAttribution) return;
      var values;
      try {
        values = window.wkdAttribution.fields();
      } catch (err) {
        return;
      }
      Object.keys(values).forEach(function (name) {
        var input = form.querySelector('input[type="hidden"][name="' + name + '"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }
        input.value = values[name];
      });
    }
    stampAttribution();
    form.addEventListener('submit', stampAttribution, true);

    // ---- Turnstile ----
    // Rendered on page load (explicit mode, see the markup note). Cloudflare's
    // own retry is off; we retry here instead: up to TS_MAX_TRIES attempts with
    // a growing pause, and the customer sees nothing while that happens. Only
    // when every attempt failed (or no token after TS_WAIT_MS at submit) do they
    // get the email fallback, with Cloudflare's code. 600xxx = "generic
    // challenge failure / bot behaviour detected", documented as retryable.
    //
    // Every visit that had a problem is reported ONCE per kind to the Worker's
    // /check-event (worker/src/checkEvents.js -> Airtable Intake Rejections):
    // check_recovered, check_failed, check_left, check_blocked. Before this,
    // a failure in the browser left no trace anywhere.
    var tsWidget = form.querySelector('[data-ts-slot]');
    var tsMsg = tsWidget ? tsWidget.getAttribute('data-ts-blocked-msg') : '';
    var tsStuckMsg = tsWidget ? tsWidget.getAttribute('data-ts-stuck-msg') : '';
    var TS_WAIT_MS = 25000;
    var TS_MAX_TRIES = 4;
    var tsId = null;
    var tsRendered = false;
    var tsCodes = [];
    var tsAttempts = 0;
    var tsExhausted = false;
    var tsLastChance = false;
    var tsResetTimer = null;
    var submitted = false;
    var reported = {};
    var CHECK_ENDPOINT = String(form.action || '').replace(/\/submit$/, '/check-event');

    function report(stage) {
      if (reported[stage] || !CHECK_ENDPOINT || CHECK_ENDPOINT === form.action) return;
      reported[stage] = true;
      var body = JSON.stringify({
        stage: stage,
        codes: tsCodes.slice(-10),
        attempts: tsAttempts,
        step: current,
        page: window.location.pathname,
      });
      try {
        if (navigator.sendBeacon) navigator.sendBeacon(CHECK_ENDPOINT, body);
        else fetch(CHECK_ENDPOINT, { method: 'POST', body: body, keepalive: true, mode: 'no-cors' });
      } catch (e) {}
    }

    function resetTs(delay) {
      window.clearTimeout(tsResetTimer);
      tsResetTimer = window.setTimeout(function () {
        try {
          if (window.turnstile && tsId !== null) window.turnstile.reset(tsId);
        } catch (e) {}
      }, delay);
    }

    function renderTs() {
      if (tsRendered || !tsWidget) return;
      if (!window.turnstile || typeof window.turnstile.render !== 'function') return;
      tsRendered = true;
      try {
        tsId = window.turnstile.render(tsWidget, {
          sitekey: tsWidget.getAttribute('data-sitekey'),
          appearance: 'interaction-only',
          theme: 'light',
          retry: 'never',
          'refresh-expired': 'auto',
          callback: function () {
            tsExhausted = false;
            if (tsCodes.length) report('check_recovered');
          },
          'error-callback': function (code) {
            tsCodes.push(String(code || 'error'));
            tsAttempts++;
            if (tsAttempts < TS_MAX_TRIES) {
              resetTs(1500 * tsAttempts);
            } else {
              tsExhausted = true;
              if (tsWaitTimer) {
                stopWaiting();
                showStuck(false);
              }
            }
            return true;
          },
          'timeout-callback': function () {
            tsCodes.push('timeout');
            tsAttempts++;
            if (tsAttempts < TS_MAX_TRIES) resetTs(1000);
            else tsExhausted = true;
          },
        });
      } catch (err) {
        tsCodes.push('render');
        tsExhausted = true;
      }
    }
    window.wkdQpfTsRenderers.push(renderTs);
    renderTs(); // in case Cloudflare's script finished loading first

    var tsWaitTimer = null;
    var tsPollTimer = null;
    var submitBtn = form.querySelector('[data-submit]');
    var submitLbl = submitBtn ? submitBtn.querySelector('[data-submit-label]') : null;
    var submitDefault = submitLbl ? submitLbl.textContent : '';

    function tsMissing() {
      return !!tsWidget && typeof window.turnstile === 'undefined';
    }
    function tsToken() {
      var input = form.querySelector('input[name="cf-turnstile-response"]');
      return input ? input.value : '';
    }
    function showStuck(quiet) {
      var box = stepError(steps.length);
      if (!box) return;
      var link = document.createElement('a');
      link.href = 'mailto:Wes@weskleedesigns.com?subject=' + encodeURIComponent('Artwork preview photo');
      link.textContent = 'Email your photo to Wes@weskleedesigns.com';
      link.style.cssText = 'color:inherit;text-decoration:underline;';
      box.textContent = tsStuckMsg + ' ';
      box.appendChild(link);
      var code = tsCodes.length ? tsCodes[tsCodes.length - 1] : '';
      if (code) {
        var codeEl = document.createElement('span');
        codeEl.textContent = ' (security check code ' + code + ')';
        codeEl.style.cssText = 'opacity:.75;';
        box.appendChild(codeEl);
      }
      box.hidden = false;
      if (!quiet) box.scrollIntoView({ block: 'center' });
      report('check_failed');
    }
    function stopWaiting() {
      window.clearTimeout(tsWaitTimer);
      window.clearInterval(tsPollTimer);
      tsWaitTimer = null;
      tsPollTimer = null;
      if (submitLbl) submitLbl.textContent = submitDefault;
      if (submitBtn) submitBtn.removeAttribute('aria-busy');
    }
    function beginSending() {
      submitted = true;
      if (submitLbl) submitLbl.textContent = 'Uploading your photo…';
      // Deferred: disabling the submitter synchronously inside a submit
      // handler makes the browser abort the submission (CLAUDE.md).
      window.setTimeout(function () {
        if (!submitBtn) return;
        submitBtn.setAttribute('aria-busy', 'true');
        submitBtn.disabled = true;
      }, 0);
      track('PreviewSubmitClicked');
    }
    function sendNow() {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        beginSending();
        form.submit();
      }
    }
    function waitForToken() {
      if (tsWaitTimer) return;
      if (submitLbl) submitLbl.textContent = 'Checking… one moment';
      if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');
      tsPollTimer = window.setInterval(function () {
        if (tsToken()) {
          stopWaiting();
          sendNow();
        }
      }, 400);
      tsWaitTimer = window.setTimeout(function () {
        stopWaiting();
        showStuck(false);
      }, TS_WAIT_MS);
    }

    // Leaving while the check is failing (or never loaded) is the case that
    // used to be invisible. Not on a real submit (that is a navigation too).
    window.addEventListener('pagehide', function () {
      if (submitted || tsToken()) return;
      if (tsWidget && tsMissing() && current >= steps.length) report('check_blocked');
      else if (tsCodes.length && !reported.check_failed) report('check_left');
    });

    // Enter in a text box on step 1 would submit the whole form; treat it
    // as Continue instead. Every step is re-checked before anything is sent.
    form.addEventListener('submit', function (e) {
      clearErrors();
      if (current < steps.length) {
        e.preventDefault();
        next();
        return;
      }
      for (var n = 1; n <= steps.length; n++) {
        if (!validate(n, true)) {
          e.preventDefault();
          show(n);
          validate(n);
          return;
        }
      }
      if (tsMsg && tsMissing()) {
        e.preventDefault();
        fail(steps.length, tsMsg);
        report('check_blocked');
        return;
      }
      if (tsWidget && tsStuckMsg && !tsToken()) {
        e.preventDefault();
        if (tsExhausted) showStuck(false);
        else waitForToken();
        return;
      }
      beginSending();
    });

    // A browser back/forward cache restore must not leave the button stuck on
    // "Uploading…".
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && submitBtn) {
        submitBtn.disabled = false;
        stopWaiting();
      }
    });

    // The Worker sends failures back here with ?preview_error=<code>. The
    // page is a fresh load, so the form starts again at step 1.
    var MESSAGES = {
      verification_failed: 'The security check failed. Please try again.',
      missing_email: 'Please enter your email.',
      missing_photo: 'Please add a photo of your car.',
      bad_photo_type: "That file type isn't supported. Please upload a JPG, PNG, HEIC or WEBP photo.",
      photo_too_large: 'That photo is over 20MB. Please choose a smaller one.',
      not_qualified: 'Previews are for people thinking about ordering a finished piece.',
      missing_qualification: 'Please pick the look and lighting you like, and Fine Art Print or Canvas.',
      missing_acknowledgment: 'Please tick the box confirming you understand how the preview works.',
      missing_vehicle: 'Please tell me the year, make and model of your car.',
      server_error: 'Something went wrong on my end. Please try again in a moment.',
    };
    var code = new URLSearchParams(window.location.search).get('preview_error');
    if (code && pageError) {
      pageError.textContent = (MESSAGES[code] || MESSAGES.server_error) + ' Your photo needs to be added again.';
      pageError.hidden = false;
      if (formTop) formTop.scrollIntoView({ block: 'start' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["style-selector"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-style-group]').forEach(function (group) {
    var cards = Array.prototype.slice.call(group.querySelectorAll('[data-style-card]'));
    if (!cards.length) return;
    var out = group.parentElement.querySelector('[data-chosen-out]');

    function select(card, focus) {
      cards.forEach(function (c) {
        var on = c === card;
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.setAttribute('tabindex', on ? '0' : '-1');
      });
      if (out) out.textContent = card.getAttribute('data-chosen-line') || '';
      if (focus) card.focus();

      document.dispatchEvent(
        new CustomEvent('wkd:style', { detail: { key: card.getAttribute('data-style-key') } })
      );
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () {
        select(card, false);
      });

      card.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          select(card, false);
          return;
        }
        var dir = 0;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
        if (!dir) return;
        e.preventDefault();
        select(cards[(i + dir + cards.length) % cards.length], true);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tm-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-tm-track]');
    if (!track) return;

    function pause() {
      track.style.animationPlayState = 'paused';
    }

    if (slider.classList.contains('tm-pause-int')) {
      slider.addEventListener('touchstart', pause, { passive: true });
      slider.addEventListener('pointerdown', pause, { passive: true });
    }

    // Desktop arrows. They live in .tm-viewport (a sibling context to the
    // scroll container), so reach back up for them. Always pause on click,
    // regardless of the "Pause on hover / touch" setting — scrolling a
    // strip that is still sliding underneath you reads as broken.
    var viewport = slider.closest('.tm-viewport');
    if (!viewport) return;

    viewport.querySelectorAll('[data-tm-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        pause();
        var dir = parseInt(btn.getAttribute('data-tm-nav'), 10);
        slider.scrollBy({ left: dir * slider.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upsell-cards"] && !Shopify.designMode) return;
  try {
    
  // Shared by the referral button and any card CTA marked data-share (e.g.
  // "Give One as a Gift"): adapt to the device, decided here rather than in
  // Liquid since it depends on the visitor's own browser. Desktop always
  // gets mailto: regardless of Web Share support, per the explicit ask
  // that desktop hands off to email specifically.
  function wireShareLink(link, url, text, subject, mobileLabel, desktopLabel) {
    if (!link || !url) return;
    mobileLabel = mobileLabel || link.textContent;
    desktopLabel = desktopLabel || link.textContent;
    var isMobile = (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) ||
      /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isMobile && navigator.share) {
      link.textContent = mobileLabel;
      link.addEventListener('click', function (e) {
        e.preventDefault();
        navigator.share({ title: subject, text: text, url: url }).catch(function () {
          /* customer backed out of the share sheet — nothing to do */
        });
      });
    } else if (isMobile) {
      link.textContent = mobileLabel;
      // iOS wants "sms:&body=", Android wants "sms:?body=" — no phone
      // number, so the customer picks the recipient themselves.
      var isIOS = /iP(hone|ad|od)/.test(navigator.userAgent);
      link.href = 'sms:' + (isIOS ? '&' : '?') + 'body=' + encodeURIComponent(text + ' ' + url);
    } else {
      link.textContent = desktopLabel;
      link.href = 'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(text + ' ' + url);
    }
  }

  document.querySelectorAll('[data-share]').forEach(function (link) {
    wireShareLink(
      link,
      link.getAttribute('data-share-url'),
      link.getAttribute('data-share-text') || '',
      link.getAttribute('data-share-subject') || '',
      link.getAttribute('data-share-label-mobile'),
      link.getAttribute('data-share-label-desktop')
    );
  });

  document.querySelectorAll('[data-referral]').forEach(function (root) {
    var input = root.querySelector('[data-ref-input]');
    var btn = root.querySelector('[data-ref-copy]');
    var shareLink = root.querySelector('[data-ref-share]');

    if (shareLink && input) {
      wireShareLink(
        shareLink,
        input.value,
        root.getAttribute('data-share-text') || '',
        root.getAttribute('data-share-subject') || '',
        root.getAttribute('data-mobile-label'),
        root.getAttribute('data-desktop-label')
      );
    }

    if (!input || !btn) return;
    var original = btn.textContent;

    btn.addEventListener('click', function () {
      input.select();
      input.setSelectionRange(0, 99999);

      function done() {
        btn.textContent = 'Copied ✓';
        setTimeout(function () {
          btn.textContent = original;
        }, 2000);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(input.value).then(done, function () {
          try {
            document.execCommand('copy');
            done();
          } catch (e) {
            /* selection is left in place so the customer can copy manually */
          }
        });
      } else {
        try {
          document.execCommand('copy');
          done();
        } catch (e) {
          /* same fallback */
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
